export type Language = 'en' | 'tr'

const en = {
  language: {
    select: 'Language',
    en: 'English',
    tr: 'Türkçe',
  },
  login: {
    signInTitle: 'Sign in to continue',
    discordDesc: 'Use your Discord account to access the dashboard',
    continueWithDiscord: 'Continue with Discord',
    securedOAuth: 'Secured with OAuth 2.0',
    errors: {
      not_member: 'Your Discord account is not a TLL or TLLA member.',
      token_failed: 'Could not connect to Discord. Please try again.',
      user_fetch_failed: 'Failed to retrieve Discord user info.',
      generic: 'An error occurred. Please try again.',
    },
    copyright: '© {year} baysal · All rights reserved',
  },
  nav: {
    dashboard: 'Dashboard',
    competitive: 'COMPETITIVE',
    members: 'Members',
    matches: 'Matches',
    events: 'Events',
    activity: 'Activity',
    calendar: 'Calendar',
    strategy: 'Strategy',
    management: 'MANAGEMENT',
    applications: 'Applications',
    supporters: 'Supporters',
    briefing: 'Briefing',
    settings: 'Settings',
    signOut: 'Sign out',
    profile: 'Profile',
    newBadge: 'NEW',
  },
  roles: {
    owner: 'Leader',
    admin: 'Admin',
    moderator: 'Moderator',
    strategist: 'Strategy',
    member: 'Member',
  },
  dashboard: {
    title: 'Dashboard',
    online: 'ONLINE',
    noUsersOnline: 'No users online',
    others: '+{n} others',
    comp: 'COMP',
    totalMembers: 'TOTAL MEMBERS',
    mainTeam: 'MAIN TEAM',
    academy: 'ACADEMY',
    inactive: 'INACTIVE',
    inactiveHint: 'Not counted in total members',
    onlineInDiscord: 'ONLINE IN DISCORD',
    upcomingEvents: 'UPCOMING EVENTS',
    noUpcomingEvents: 'No upcoming events',
    upcomingMatches: 'UPCOMING MATCHES',
    noUpcomingMatches: 'No upcoming matches',
    recentJoins: 'NEW TO THE CLAN',
    noRecentJoins: 'Nobody has joined recently',
    joinedApprox: 'Approximate, predates our records',
    teamActivity: 'TEAM ACTIVITY',
    personalActivity: 'YOUR ACTIVITY',
    activityHint: 'Activity is answering a match: playing, bench, not sure and not coming all count.',
    activityDetails: 'Details',
    actRate: 'ANSWER RATE',
    actLastN: 'last {n} matches',
    actAnswers: '{a}/{e} answers',
    actMine: 'you answered {a} of {e} matches',
    actNothingYet: 'no match has closed since you joined',
    actNoMatches: 'No match has closed its sign-up yet.',
    actPrimary: 'PLAYING',
    actBench: 'BENCH',
    actTentative: 'NOT SURE',
    actOut: 'NOT COMING',
    actOther: 'OTHER',
    actSilent: 'No answer',
    actAnswered: 'Answered',
    actBefore: 'Before you joined',
    actAlways: 'answered every match',
    actNever: 'answered none',
    actStreak: 'matches answered in a row',
    actPending: 'waiting for your answer',
    actNoPending: 'No match is waiting for your answer.',
    notifications: 'NOTIFICATIONS',
    noNotifications: 'No notifications yet',
    signedUp: 'Signed up',
    notSignedUp: 'Not signed up',
    cancelSignUp: 'Cancel Sign-up',
    signUp: 'Sign Up',
    chooseClass: 'CHOOSE CLASS',
    confirm: 'Confirm',
    areYouSure: 'Are you sure?',
    yes: 'Yes',
    no: 'No',
    viewInDiscord: 'View in Discord',
    confirmDecline: 'Confirm / Decline',
    new: 'NEW',
    rosterPlacement: 'ROSTER PLACEMENT',
    rosterPlacementDesc: 'You have been placed in a roster position. Please confirm or decline.',
    benchPlacementDesc: 'You have been assigned to the bench. Please confirm or decline.',
    strategyPosted: 'STRATEGY',
    strategyPostedDesc: 'The match strategy is out: {name}.',
    signupReminder: 'SIGN-UP',
    signupReminderDesc: 'The roster is being built soon. Pick your position, or say you are not coming.',
    rosterUpdate: 'ROSTER UPDATE',
    rosterAddedDesc: 'You have been added to the roster. Please confirm or decline.',
    rosterMovedDesc: 'Your roster position has been changed. Please confirm or decline.',
    rosterRemovedDesc: 'You have been removed from the roster.',
    rosterUpdatedDesc: 'Your roster has been updated. Please confirm or decline.',
    newMatch: 'NEW MATCH',
    notSignedUpYet: 'You are not signed up yet.',
    goToEvent: 'Go to event',
    justNow: 'just now',
    mAgo: '{n}m ago',
    hAgo: '{n}h ago',
    dAgo: '{n}d ago',
  },
  members: {
    title: 'Members',
    searchPlaceholder: 'Search members...',
    loading: 'Loading…',
    count: '{n} members',
    exportMembers: 'Export Members',
    refresh: 'Refresh',
    serverError: 'Failed to reach the server.',
    noMembers: 'No members found with TLL or TLLA roles.',
    tllSection: 'TLL · {n} members',
    tllaSection: 'TLLA · {n} members',
    online: 'Online now',
    lastSeen: 'Last seen: {t}',
    never: 'Never',
    justNow: 'Just now',
    mAgo: '{n}m ago',
    hAgo: '{n}h ago',
    dAgo: '{n}d ago',
    moAgo: '{n}mo ago',
    playtimeHours: '{n}h',
    playtimeMinutes: '{n}m',
    playtimeTotal: 'Total',
    playtimeFortnight: '2 wk',
    playtimeTotalHint: 'Total WARDOGS playtime, from Steam.',
    playtimeFortnightHint: 'WARDOGS played in the last 2 weeks, from Steam.',
    playtimePrivate: 'Private',
    playtimePrivateHint: 'Game details are private on this Steam profile, so playtime cannot be read.',
    playtimeTotalColumn: 'WARDOGS hours (total)',
    playtimeFortnightColumn: 'WARDOGS hours (2 weeks)',
    sortLabel: 'Sort',
    sortBy: {
      name: 'Name',
      lastSeen: 'Last seen',
      playtimeTotal: 'Total playtime',
      playtimeFortnight: 'Playtime (2 weeks)',
      clanJoined: 'Joined clan',
    },
    sortAsc: 'Ascending, click to reverse',
    sortDesc: 'Descending, click to reverse',
    onlineShort: 'Online',
    noMatches: 'No members match this search.',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    detailDiscord: 'Discord',
    detailLastSeen: 'Last seen',
    detailJoined: 'Joined the clan',
    detailPlaytime: 'WARDOGS playtime',
    detailSteam: 'Steam',
    positions: {
      label: 'Positions',
      mine: 'Positions you want to play',
      mineHint: 'Pick as many as you like. They show next to your name in the member list.',
      noOptions: 'No positions have been defined yet.',
      specsHint: 'Sub-classes are optional. Pick the ones you want to play in each position.',
      saveError: 'Could not save your positions. Try again.',
      filterAll: 'All',
      filterNone: 'Not chosen',
      filterLabel: 'Filter by position',
      none: 'Not chosen',
      column: 'Positions',
    },
    cancel: 'Cancel',
    save: 'Save',
    ownerLocked: 'Leader · locked',
    role: 'Role',
    steamVerified: 'Verified through Steam',
    steamUnverified: 'unverified',
    steamNotLinked: 'Steam not linked',
    steamAccount: 'Steam account',
    // Linked, but Steam gave us no name for it (private profile, lookup failed).
    steamNoName: 'Name unavailable',
    steamOpenProfile: 'Open Steam profile',
    steamLinkTitle: 'Link your Steam account',
    steamLinkBody: 'Server priority is granted to a SteamID64, so we need one you have proved is yours.',
    steamLinkCta: 'Link Steam account',
    steamRelinkCta: 'Link a different account',
    steamUnlinkCta: 'Unlink',
    steamLinkedToast: 'Steam account linked.',
    steamFailedToast: 'Steam did not confirm that sign-in. Please try again.',
    steamTakenToast: 'That Steam account is already linked to another Discord account.',
    // Staff-only panel on each card: notes + hand-entered SteamID64.
    manage: {
      open: 'Staff notes & Steam',
      staffOnly: 'Only the leader, admins and moderators can see this.',
      steamTitle: 'SteamID64',
      steamPlaceholder: '7656119… or steamcommunity.com link',
      steamSave: 'Save',
      steamClear: 'Remove',
      steamClearConfirm: "Remove this member's Steam link?",
      steamHint: 'A hand-entered id stays unverified until the member links it through Steam themselves.',
      steamSaved: 'SteamID saved.',
      steamCleared: 'Steam link removed.',
      steamInvalid: 'Not a SteamID64 or Steam profile link.',
      steamTaken: 'That Steam account is already linked to another member.',
      steamError: 'Could not save. Try again.',
      notesTitle: 'Notes',
      notePlaceholder: 'Write a note about this player… (Ctrl+Enter to save)',
      noteAdd: 'Add note',
      notesEmpty: 'No notes yet.',
      notesLoadError: 'Could not load notes.',
      noteSaveError: 'Could not save the note.',
      noteDelete: 'Delete note',
      noteDeleteConfirm: 'Delete this note?',
      noteDeleteError: 'Could not delete the note.',
    },
    // Wardogs League (wardogsleague.net) takım kadrosu — backend/wdl/.
    wdl: {
      title: 'Wardogs League roster',
      hint: 'Clan members who apply to the team on wardogsleague.net are accepted automatically. The API cannot add anyone directly, so a player has to apply first.',
      refresh: 'Sync',
      notConfigured: 'WDL_API_KEY is not set, so the league sync is off.',
      unauthorized: 'The Wardogs League key was rejected. Check WDL_API_KEY.',
      unavailable: 'Wardogs League could not be reached. Showing the last known roster.',
      loadError: 'Could not load the league roster.',
      stats: '{roster} on the league roster · {clan} in the clan · {missing} missing',
      synced: 'synced {t}',
      autoAcceptOff: 'Auto-accept is off (WDL_AUTO_ACCEPT=0).',
      missingTitle: 'In the clan, not on the roster ({n})',
      missingNone: 'Every clan member is on the league roster.',
      pendingTitle: 'Pending applications ({n})',
      pendingNotClan: 'not in the clan',
      accept: 'Accept',
      decline: 'Decline',
      declineConfirm: 'Decline this application on Wardogs League?',
      respondError: 'Could not answer the application.',
      outsidersTitle: 'On the roster, not in the clan ({n})',
      acceptedTitle: 'Recently auto-accepted',
    },
  },
  events: {
    title: 'Events',
    loading: 'Loading…',
    count: '{n} events',
    refresh: 'Refresh',
    noEvents: 'No events found.',
    loadingEvents: 'Loading events…',
    selectEvent: 'Select an event to view details',
    backToEvents: '← Back to events',
    backToDetails: '← Back to details',
    signedUp: 'Signed up',
    notSignedUp: 'Not signed up',
  },
  matches: {
    title: 'Matches',
    header: 'MATCHES',
    loading: 'Loading…',
    noMatches: 'No matches found.',
    serverError: 'Failed to reach the server.',
    newMatch: 'New match',
    createMatch: 'Create match',
    editMatch: 'Edit match',
    deleteConfirm: 'Delete this match? The Discord post will be removed too.',
    formTitle: 'Title',
    formTitlePh: 'e.g. TLL vs WDUK vs 331',
    formTeams: 'Teams',
    formTeamPh: 'Team {n}',
    formFactionNone: 'Side',
    formDate: 'Date',
    formTime: 'Match time',
    formBriefing: 'Briefing',
    briefing: 'Briefing',
    kickoff: 'Match',
    notSetYet: 'Not decided yet',
    staffOnly: 'Staff only',
    formMap: 'Map',
    formMapNone: 'Not decided yet',
    formDescription: 'Description',
    formDescriptionPh: 'Optional: opponent, rules…',
    formRequired: 'Title, date and time are required.',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    saveError: 'Could not save the match.',
    postedToForum: 'Gets its own Discord channel: sign-up, roster, strategy.',
    strategyTitle: 'Strategy',
    strategyNotPublished: 'No strategy published yet.',
    strategyNoneLinked: 'No strategy is linked to this match.',
    strategyOpenLibrary: 'Open one in the library',
    strategyPublish: 'Publish to Discord',
    strategyUpdate: 'Update on Discord',
    strategyUnpublish: 'Unpublish',
    strategyPublishHint: 'Fills message 3 of the match channel. Only players placed in the published roster are notified.',
    strategyPublished: 'Published.',
    strategyPublishedNotified: 'Published. {n} player(s) notified.',
    strategyUnpublished: 'Unpublished.',
    strategyError: 'Could not publish the strategy.',
    strategySlides: '{n} slides',
    stepSignup: 'Sign-up',
    stepPosition: 'Position',
    stepStrategy: 'Strategy',
    yourTurn: 'Your move',
    stepSignupDone: 'Signed up as {class}',
    stepSignupTodo: "You haven't signed up",
    stepSignupNone: "You didn't sign up",
    stepPositionWaiting: 'Roster not published yet',
    stepPositionOut: "You're not in the roster",
    stepPositionBench: "You're on the bench",
    stepStrategyWaiting: 'Not published yet',
    openChannel: 'Match channel',
    yourSignUp: 'Your sign-up',
    yourPosition: 'Your position',
    signUpsTitle: 'Signed up',
    playingCount: '{n} playing',
    benchCount: '{n} on the bench',
    noSignUpsYet: 'No one has signed up yet.',
    reminderTitle: 'Awaiting a decision',
    reminderCount: '{n} members',
    reminderHint: 'The reminder DMs everyone below, adds a panel notification and tags them in the match channel; the tags and notifications are removed when the roster is posted.',
    reminderGroupUndecided: 'Undecided',
    reminderGroupNone: 'No answer',
    reminderAllAnswered: 'Everyone in the clan has decided.',
    reminderSend: 'Remind ({n})',
    reminderConfirm: 'DM {n} members and tag them in the channel?',
    reminderConfirmYes: 'Send',
    reminderCancel: 'Cancel',
    reminderSent: 'Reminder sent to {n} members.',
    reminderLast: 'Last reminder {ago} · {name}',
    reminderError: 'Could not send the reminder.',
    agoJustNow: 'just now',
    agoMinutes: '{n} min ago',
    agoHours: '{n} h ago',
    agoDays: '{n} days ago',
    positionEmpty: 'empty',
    editRoster: 'Edit roster',
    buildRoster: 'Build roster',
    rosterWaitingHint: 'Once staff publish the roster, your squad and role show up here and you confirm them.',
    rosterWaitingStaff: 'Place the signed-up players in squads, then send the roster to Discord. Players get a DM to confirm.',
    strategyWaitingHint: 'Staff publish the strategy after the roster; players in the roster get a DM.',
    relLive: 'Under way',
    relPlayed: 'Played',
    relMinutes: 'in {n} min',
    relHours: 'in {n} h',
    relTomorrow: 'Tomorrow',
    relDays: 'in {n} days',
    listConfirm: 'Confirm your position',
    listSignUp: 'Sign up',
    listBench: 'On the bench',
    listInRoster: "You're in",
    listDeclined: 'You declined',
    listSigned: 'Signed up · {class}',
    upcomingTitle: 'Upcoming',
    pastTitle: 'Past matches',
    refresh: 'Refresh',
    noUpcoming: 'No matches coming up.',
    noUpcomingStaff: 'Create one with New match.',
    noUpcomingMember: "You'll get a DM when one is created.",
    noMatchSelectedHint: 'Pick a match on the left to sign up, see your position and read the strategy.',
    signedUp: 'Signed up',
    notSignedUp: 'Not signed up',
    external: 'External',
    history: 'HISTORY',
    showHistory: 'Show match history',
    hideHistory: 'Hide match history',
    backToList: '← Back to match list',
    configureRoster: 'Configure Roster',
    backToDetails: '← Back to details',
    viewInDiscord: 'View in Discord',
    noMatchSelected: 'Select a match to view details',
    matchGone: 'This match is no longer here',
    matchGoneHint: 'The link points to a match that was deleted, or one you cannot see. Pick another on the left.',
  },
  settings: {
    title: 'Settings',
    squadPresets: 'Squad Presets',
    squadPresetsDesc: 'Manage squad presets that appear in the strategy editor marker properties. These presets are available to all users when assigning squads to markers.',
    noSquadPresets: 'No squad presets yet. Add one below.',
    newSquadName: 'New squad name...',
    add: 'Add',
    vehiclePresets: 'Vehicle Presets',
    vehiclePresetsDesc: 'Manage vehicle presets used by arrow properties in the strategy editor. Each preset has a name and a speed (km/h).',
    noVehiclePresets: 'No vehicle presets yet. Add one below.',
    newVehicleName: 'New vehicle name...',
    speed: 'Speed',
    matchClasses: 'Lineup',
    matchClassesDesc: 'The positions players sign up for on dashboard matches. Order here is the order they see: in the picker, in the Discord dropdown and in the match channel. Only the admin team can change them.',
    rosterDefault: 'Default Roster',
    rosterDefaultDesc: 'The squad layout a match roster opens with. A match whose roster was already saved keeps its own. Only the admin team can change it.',
    rosterDefaultSummary: '{squads} squads · {slots} slots',
    rosterDefaultEmpty: 'No squads yet, so match rosters open empty. Add squads below.',
    rosterDefaultNamePh: 'Squad name',
    rosterDefaultAdd: 'Add squad:',
    rosterDefaultSave: 'Save',
    rosterDefaultSaving: 'Saving…',
    rosterDefaultSaved: 'Saved',
    rosterDefaultSaveError: 'Could not save the default roster.',
    rosterDefaultUnknownType: 'This squad type no longer exists. Delete the squad.',
    rosterRoles: 'Roster Roles',
    rosterRolesDesc: 'The roles a roster slot can have, each with its Discord emoji. The emoji is shown in the roster builder, in match details and in the Discord roster post. Right-clicking a player offers these as extra roles too.',
    rosterRolesEmpty: 'No roles yet.',
    rosterRoleNamePh: 'Role name',
    rosterRoleUsedBy: 'used by {n} squad type(s)',
    rosterAdd: 'Add',
    rosterCatalogDiscard: 'Discard changes',
    rosterCatalogSaveError: 'Could not save roles and squad types.',
    squadTypes: 'Squad Types',
    squadTypesDesc: 'What kinds of squads a roster can have and which roles fill them. Min and max limit the slots per role; default is what a newly added squad starts with. Min = max makes a slot fixed. Roles and squad types are saved together.',
    squadTypeRole: 'Role',
    squadTypeMin: 'Min',
    squadTypeDefault: 'Default',
    squadTypeMax: 'Max',
    squadTypeAddRule: 'Add role',
    squadTypeNoRules: 'No roles. Add at least one, or delete this type.',
    rosterProblemNoRoles: 'Add at least one role.',
    rosterProblemRoleName: 'A role has no name.',
    rosterProblemNoTypes: 'Add at least one squad type.',
    rosterProblemTypeName: 'A squad type has no name.',
    rosterProblemTypeNoRoles: "'{name}' has no roles. Add one or delete the type.",
    squadTypeNamePh: 'Squad type name',
    noMatchClasses: 'No positions yet. Add one below. Without any, nobody can sign up.',
    newClassName: 'New position name...',
    classEmoji: 'Emoji',
    emojiSearch: 'Search emoji...',
    emojiFromServer: 'From our Discord',
    emojiUnicode: 'Plain emoji',
    emojiLoading: 'Loading emoji…',
    emojiGroups: ['Smileys', 'People', 'Components', 'Animals & nature', 'Food & drink', 'Travel & places', 'Activities', 'Objects', 'Symbols', 'Flags'],
    emojiNone: 'No custom emoji on the server.',
    emojiNoMatch: 'No emoji matches that.',
    emojiClear: 'Remove emoji',
    classKindPrimary: 'Playing',
    classKindBench: 'Substitute',
    classKindTentative: 'Undecided',
    classKindOut: 'Not attending',
    classMoveUp: 'Move up',
    classMoveDown: 'Move down',
    classSaveError: 'Could not save the position.',
    classSpecs: 'Sub-classes',
    classSpecsHint: "Offered once this position is picked, on the dashboard and in Discord. Optional: players can sign up without one. A player's last pick is remembered until they change it.",
    newSpecName: 'New sub-class...',
    noClassSpecs: 'No sub-classes: the position is picked on its own.',
    removeSpec: 'Remove sub-class',
  },
  calendar: {
    title: 'Calendar',
    days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    noEvents: 'No events or matches this month.',
    refresh: 'Refresh',
    today: 'Today',
    eventLegend: 'Event',
    matchLegend: 'Match',
    externalMatch: 'External Match',
    signedUp: 'signed up',
  },
  eventDetail: {
    removedClass: 'removed',
    changeSignUp: 'Change position',
    changeSignUpHint: 'Pick your new position.',
    changeSignUpSave: 'Switch',
    removedClassHint: 'This position was removed from Settings → Lineup. These sign-ups are not counted until the players pick a new position.',
    yourSignUp: 'YOUR SIGN UP',
    yourPosition: 'YOUR POSITION',
    cancelSignUp: 'Cancel Sign-Up',
    notSignedUp: 'You are not signed up',
    chooseClass: 'Choose Your Class',
    chooseSpec: 'Sub-class (optional)',
    signUp: 'Sign Up',
    positionConfirmed: 'Confirmed',
    positionDeclined: 'Declined',
    confirm: 'Confirm',
    decline: 'Decline',
    benchPosition: 'Bench',
    benchPositionHint: 'You may be moved into a squad if needed.',
    declineReasonLabel: 'Why are you declining?',
    declineReasonPlaceholder: "Can't make the match, or don't like your position? If it's the position, which one would you rather play? The staff will rebuild the roster around it.",
    declineReasonTooShort: 'Write a reason to decline.',
    declineSubmit: 'Send decline',
    declineReasonYours: 'Your reason: {reason}',
    rosterNotPosted: 'Roster not posted yet',
    notInRoster: 'You are not in the roster',
    signedUpSection: 'SIGNED UP ({n})',
    noSignUps: 'No sign-ups yet',
    squadLayout: 'SQUAD LAYOUT',
    rosterLayout: 'ROSTER LAYOUT',
    externalModify: 'Modification not available for external events',
    externalNotAvailable: 'External event, sign-up not available',
    viewInDiscord: 'View in Discord',
    signedUpCount: 'signed up',
    emptySlot: 'Empty',
    confirmAction: 'Confirm',
    cancelAction: 'Cancel',
    removeMatchTitle: 'Remove match',
    editMatchTitle: 'Edit match',
  },
  squadBuilder: {
    rosterConfiguration: 'ROSTER CONFIGURATION',
    addMember: 'Add Member',
    addSquad: 'Add Squad',
    saved: 'Saved',
    save: 'Save',
    update: 'Update',
    send: 'Send',
    updating: 'Updating…',
    sending: 'Sending…',
    updated: 'Updated',
    sent: 'Sent',
    updateDiscordTitle: 'Update Discord embed',
    sendDiscordTitle: 'Send squad config to Discord channel',
    searchMembers: 'Search members…',
    noMembersFound: 'No members found',
    extraRoles: 'EXTRA ROLES',
    wantedSpec: 'Signed up as: {spec}',
    slotConfig: 'SLOT CONFIG',
    unassigned: 'UNASSIGNED ({n})',
    unassignedHint: 'Anyone left here is published as bench.',
    benchTag: 'Bench',
    declinedReason: 'Declined: {reason}',
    search: 'Search…',
    allAssigned: 'All assigned',
    removed: 'REMOVED FROM ROSTER ({n})',
    removedEmpty: 'Drop players here to take them off the roster entirely',
    tentative: 'TENTATIVE',
    absent: 'ABSENT',
    overview: 'OVERVIEW',
    total: 'Total',
    loading: 'Loading…',
    noSquads: 'Click "Add Squad" to create squads',
    noSlots: 'No slots configured',
    rightClickHint: 'Right-click for extra roles · Double-click to unassign',
    tapPickHint: 'Tap a player, then tap a slot or squad to place',
    tapPlaceHint: 'Tap a slot or squad to place · tap the pools to send back',
    tapCancel: 'Cancel',
    dragSquadHint: 'Drag to move the squad',
  },
  strategyEditor: {
    collapsePanel: 'Collapse panel',
    expandPanel: 'Expand panel',
    noteAssignPlayers: 'Note & Assign Players',
    noContent: 'No content',
    note: 'Note',
    notePlaceholder: 'Add a note for this SP...',
    players: 'Players',
    searchMember: 'Search member...',
    filterPlaceholder: 'Player or squad name...',
    squadsSection: 'Squads',
    playersSection: 'Players',
    toolSelect: 'Select',
    toolPing: 'Ping',
    toolArrow: 'Arrow',
    toolCircle: 'Circle',
    toolPolygon: 'Polygon',
    toolText: 'Text',
    toolMarker: 'Markers',
    toolMarkerSingle: 'Marker',
  },
  activity: {
    title: 'Activity',
    loadError: 'Failed to reach the server.',
    refresh: 'Refresh',
    daysShort: 'd',
    noMatches: 'No matches in this range.',

    // ── Turnout band ──────────────────────────────────────────────────────
    turnout: 'MATCH TURNOUT',
    statMatches: 'MATCHES',
    statAvg: 'AVG TURNOUT',
    statBest: 'BEST',
    statPlayers: 'PLAYERS',
    seriesPlayed: 'Played',
    seriesBenched: 'Signed up, sat out',
    totalSignUps: 'Total sign-ups',
    clickHint: 'Click a match to open its roster.',

    // ── Match panel ───────────────────────────────────────────────────────
    matchRoster: 'ROSTER',
    close: 'Close',
    noRoster: 'Nobody signed up.',
    mapUnknown: 'Map not set',
    externalTag: 'ext',

    // ── Ranking ───────────────────────────────────────────────────────────
    ranking: 'ATTENDANCE RANKING',
    searchPlayers: 'Search players...',
    sortPlayed: 'Played',
    sortRate: 'Rate',
    sortRateHint: 'Share of the matches held since the player turned up. A newcomer is not marked down for the ones that ran before them.',
    sinceJoin: 'since {date}',
    wholeRange: 'whole range',
    noPlayers: 'Nobody matches that.',
    you: '(you)',

    // ── Player panel ──────────────────────────────────────────────────────
    player: 'PLAYER',
    selectPlayer: 'Pick a player to see every match they were called to.',
    played: 'Played',
    rate: 'Rate',
    streak: 'Streak',
    record: 'MATCH BY MATCH',
    recordHint: 'One cell per match, oldest on the left.',
    history: 'HISTORY',
    backToList: '\u2190 Back',

    // ── Per-player states ─────────────────────────────────────────────────
    statePlayed: 'Played',
    stateBench: 'Bench',
    stateOut: 'Did not play',
    stateAbsent: 'No sign-up',

    // ── Inactive members ──────────────────────────────────────────────────
    inactiveTitle: 'INACTIVE',
    inactiveHint: 'Members who answered none of the last {n} matches. (No "Position", "Not sure" or "Not coming" picked)',
    inactiveNone: 'Nobody is inactive.',
    inactiveWaiting: 'Counting starts after {n} closed matches ({have} so far).',
    inactiveDisabled: 'The automatic pass is off (INACTIVITY_ENABLED=0). The list and restoring still work.',
    inactiveSince: 'inactive since {date}',
    inactiveRestore: 'Restore',
    inactiveRestoreHint: 'Give back the team roles that were taken and remove the inactive role.',
    inactiveRestoreFailed: 'Could not restore the roles on Discord.',
    teamMember: 'Member',
    teamAcademy: 'Academy',
  },
  strategy: {
    // ── Strateji sekmesi — üç bölüm ───────────────────────────────────────
    pageTitle: 'Strategy',
    pageSubtitle: 'Match plans, the shared playbook, and the strategic point layer.',
    tabs: {
      match: 'Match Strategies',
      points: 'Strategic Points',
      playbook: 'Playbook',
    },
    sectionDesc: {
      match: 'Plans drawn for clan matches. Opened by the staff team.',
      points: 'The point layer of each map: positions, viewing angles, footage.',
      playbook: 'Open tactics anyone can share. Same editor as match plans.',
    },
    access: {
      staffOnly: 'Staff only',
      everyoneOwn: 'Everyone adds · own entries only',
      everyone: 'Open to everyone',
    },
    library: {
      newMatchStrategy: 'New match strategy',
      newPlaybookEntry: 'New tactic',
      emptyMatch: 'No match strategies yet.',
      emptyPlaybook: 'The playbook is empty. The first tactic can be yours.',
      lockedMatch: 'Match strategies are opened by the staff team.',
      search: 'Search strategy...',
      noSearchResult: 'Nothing matched.',
      slideCount: '{n} slides',
      oneSlide: '1 slide',
      noSlides: 'No slides yet.',
      addSlide: 'Add slide',
      slideName: 'Slide {n}',
      openLabel: 'Open',
      mine: 'Yours',
      noMapPicked: 'Pick a map first.',
    },
    pointsPicker: {
      hint: 'Pick a map to open its point layer.',
    },
    noMapsAvailable: 'No maps available.',
    sidebarOpen: 'Open the strategy list',
    sidebarClose: 'Close the strategy list',
    tools: {
      select: 'Select',
      ping: 'Ping',
      markers: 'Markers',
      arrow: 'Arrow',
      polygon: 'Polygon',
      circle: 'Circle',
      text: 'Text',
      ruler: 'Ruler',
      hotzone: 'Hotzone (170 m)',
    },
    home: 'Strategy home',
    untitled: 'Untitled',
    strategicPointsToggle: 'Strategic points',
    calloutsToggle: 'Callouts',
    gridToggle: 'Grid',
    rulerHint: 'Drag to measure. Esc clears.',
    hotzoneNote: 'Hotzone is a fixed 170 m circle in the in-game yellow. It can only be moved.',
    filterMarkers: 'Filter markers by player or squad',
    whoIsViewing: 'Who is viewing',
    you: 'you',
    noMatchesFound: 'No matches',
    noAssignments: 'No players or squads assigned yet',
    pickFromSidebar: 'Pick a strategy from the sidebar',
    gone: 'This strategy is no longer here',
    goneHint: 'The link points to a strategy that was deleted. Pick another from the sidebar.',
    readOnly: 'Read only',
    // ── Editör kabuğu ─────────────────────────────────────────────────────
    undo: 'Undo',
    redo: 'Redo',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomFit: 'Fit the whole map',
    saving: 'Saving',
    saved: 'Saved',
    actions: 'Actions',
    markerGroups: { tactical: 'TACTICAL', vehicles: 'VEHICLES', vehiclesSide: 'VEHICLES (SIDE VIEW)', enemy: 'ENEMY', supply: 'SUPPLY' },
    team: 'TEAM',
    teamNone: 'White',
    fobRotation: 'FOB ROTATION',
    fobRotateHint: 'Drag to rotate · Shift snaps to 15°',
    controlZone: 'Control zone: the circle fought over in that rotation',
    controlZoneOff: 'No control zone',
    fillOpacity: 'FILL OPACITY',
    fontSize: 'FONT SIZE',
    background: 'BACKGROUND',
    bgNone: 'None',
    bgSolid: 'Solid',
    bgBubble: 'Bubble',
    selectHint: 'Click an object to select it, drag to move it. Del removes the selection.',
    pingHint: 'Click anywhere on the map: everyone watching this slide sees the ping.',
    addToSlide: 'Add to slide',
    addedToSlide: 'On the slide',
    edit: 'Edit',
    duplicate: 'Duplicate',
    searchMarker: 'Search marker...',
    strategies: 'Strategies',
    refresh: 'Refresh',
    newStrategy: 'New Strategy',
    map: 'MAP',
    // Harita kartlarındaki tanıtım metinleri; anahtar katalogdaki `name`.
    mapDescriptions: {
      bakurani: 'A river valley in the mountains. The floor is open ground (factory blocks and the road that runs the length of it), while both flanks climb into forest. Whoever owns the ridgelines dictates the fight, because everything on the valley floor is observed from above.',
      ozeti: 'A river basin with a town, a stadium and farmland parcels laid out along the roads, woodland filling the gaps between them. The open ground between parcels makes movement expensive without smoke or a covered approach.',
      zesty: 'A town on a river bend, with farmland and scattered woodland spreading out around it. Away from the buildings the ground is open and dry, so cover is something you bring rather than something you find.',
    },
    mapView: {
      label: 'Map view',
      tactical: 'Tactical',
      satellite: 'Satellite',
      tacticalHint: 'Tactical view: greyscale, levelled brightness so markers read the same on every map',
      satelliteHint: 'Satellite view: raw map colours',
    },
    selectMap: 'Select map...',
    match: 'MATCH',
    optional: 'optional',
    noMatch: 'No match',
    creating: 'Creating...',
    create: 'Create',
    allStrategies: 'ALL STRATEGIES',
    noStrategies: 'No strategies yet.',
    slides: 'SLIDES',
    noSlides: 'No slides yet.',
    addSlide: 'Add Slide',
    deleteSlide: 'Delete this slide?',
    deleteStrategy: 'Delete strategy and all slides?',
    delete: 'Delete',
    cancel: 'Cancel',
    rename: 'Rename',
    copyName: '{name} (copy)',
    color: 'COLOR',
    custom: 'CUSTOM',
    squads: 'SQUADS',
    selectSquad: 'Select squad...',
    addSquad: 'Add squad...',
    members: 'MEMBERS',
    searchMember: 'Search member...',
    noMembersFound: 'No members found',
    title: 'TITLE',
    titlePlaceholder: 'Title...',
    description: 'DESCRIPTION',
    descriptionPlaceholder: 'Description...',
    strokeWidth: 'STROKE WIDTH',
    lineStyle: 'LINE STYLE',
    solid: 'Solid',
    dashed: 'Dashed',
    dotted: 'Dotted',
    arrowHead: 'ARROW HEAD',
    none: 'None',
    arrow: 'Arrow',
    flat: 'Flat',
    startMarker: 'START MARKER',
    vehicle: 'VEHICLE',
    changeVehicle: 'Change vehicle...',
    selectVehicle: 'Select vehicle...',
    noVehiclePresets: 'No vehicle presets. Add some in Settings.',
  },
  // ── Stratejik Noktalar — harita başına nokta katmanı ──────────────────────
  strategicPoints: {
    title: 'Strategic Points',
    back: 'Back to strategy',
    countLabel: 'POINTS',
    empty: 'No points on this map yet.',
    noPermission: 'You cannot edit this point.',
    yours: 'Yours',
    addedBy: 'Added by',
    iconTypes: {
      infantry: 'Infantry',
      tank: 'Tank',
      roof: 'Roof',
      bush: 'Bush',
      mg: 'MG',
      snipe: 'Sniper',
      glitch: 'Glitch',
      other: 'Other',
    },
    panel: {
      collapse: 'Collapse panel',
      expand: 'Expand panel',
      editPoint: 'Edit point',
      exitEdit: 'Leave edit mode',
      pointTitle: 'Strategic point',
      selectTitle: 'Select',
      icon: 'ICON',
      description: 'DESCRIPTION',
      notesPlaceholder: 'Notes...',
      viewingAngles: 'VIEWING ANGLES',
      media: 'MEDIA',
      noMedia: 'No media attached',
      deletePoint: 'Delete point',
      confirmDelete: 'Delete this point?',
      delete: 'Delete',
      selectIcon: 'PICK AN ICON',
      selectIconHint: 'Pick an icon, then click the map to place it.',
      idleHint: 'Click a point for its details. Right-click for more options.',
    },
    draw: {
      arrow: 'Arrow',
      polygon: 'Polygon',
      arrowFrom: 'Draw an arrow from this point',
      polygonFrom: 'Draw a polygon from this point',
      arrowHint: 'Click to set the arrow endpoint. Esc cancels.',
      polygonHint: 'Click to add vertices. Click the first handle to close. Right-click undoes the last vertex, Esc cancels.',
    },
    media: {
      upload: 'Upload image / video',
      uploading: 'Uploading...',
      linkPlaceholder: 'Paste an image / video link...',
      addLink: 'Add',
      linkFailed: 'The link could not be added.',
      deleteMedia: 'Delete media',
      expand: 'Expand',
    },
  },
  // Mevkiler: haritada adı konmuş bölgeler (stratejik noktalar bölümünde çizilir)
  callouts: {
    title: 'Callouts',
    tool: 'Callout (draw an area)',
    empty: 'No callouts on this map yet.',
    toolHint: 'Click the map to start the area. Each click adds a corner.',
    drawHint: 'Click to add corners. Click the first corner or press Enter to close. Backspace removes the last corner, Esc cancels.',
    newTitle: 'New callout',
    name: 'Name',
    namePlaceholder: 'e.g. Stadium',
    nameHint: 'What the team calls this place in game.',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete callout',
    confirmDelete: 'Delete this callout?',
    editHint: 'Drag corners to reshape. Drag a midpoint handle to add a corner, double-click a corner to remove it.',
    readOnly: 'Only the author and staff can edit this callout.',
    saveFailed: 'Could not save.',
    corners: '{n} corners',
  },
  // ── join.turksletloose.com — public recruitment site ──────────────────────
  // ── turksletloose.com (public community site) ───────────────────────────
  home: {
    pageTitle: 'Turks Let Loose',
    tagline: 'Wardogs Turkish community',
    // Short labels for the top bar. The section headings are full sentences and
    // wrap inside a 56px bar, so the nav gets its own wording.
    navCommunity: 'Community',
    navGames: 'Games',
    navCompetitive: 'Team',
    navSupporter: 'Supporter',
    footerNote: 'A player community. Not affiliated with any game or its publisher.',
    heroKicker: 'WARDOGS TURKISH COMMUNITY',
    heroTitle: 'Turks Let Loose',
    heroLead:
      'Home to the largest Wardogs server in Turkey, Turks Let Loose is a Turkish ' +
      'gaming community that takes FPS games seriously without giving up the fun. We ' +
      'play a lot of games at a competitive level, Wardogs first among them. If you ' +
      'want to play with a good crew, you are in the right place.',
    joinCta: 'Apply to the team',
    discordCta: 'Discord',
    serverCardKicker: 'OUR DISCORD SERVER',
    serverCardOnlineLabel: 'Online',
    serverCardMembersLabel: 'Members',
    serverCardCta: 'Join Discord',
    discordJoinCta: 'Join the Discord',
    dashboardLink: 'Member dashboard',

    community: {
      title: 'Community',
      body:
        'Everything happens on our Discord: game nights, competitive matches and casual ' +
        'rounds. Nobody is here for a single game. People show up because of who else is ' +
        'in the voice channel.',
      recentTitle: 'Newest arrivals',
      cta: 'Join us too',
    },

    games: {
      title: 'What we play',
      wardogsTitle: 'Wardogs',
      wardogsBody: 'Our main game. Competitive matches, training nights and soon a server of our own.',
      shootersTitle: 'Other shooters',
      shootersBody: 'The group gathers in other FPS titles too. When the crew is up, the game matters less.',
      partyTitle: 'Party games',
      partyBody: 'Every now and then we lose our minds over party games. Anyone can join in.',
      nightsTitle: 'Game nights',
      nightsBody: 'Planned nights and spur-of-the-moment lobbies, both announced on Discord.',
    },

    competitive: {
      title: 'Competitive team',
      lead:
        'Inside the community there is a roster that plays organised matches against European ' +
        'clans. It is one part of what we do, not the price of admission.',
      mainTitle: 'Main roster',
      mainBody:
        'The line-up that plays scrims and tournaments. Fixed roles, prepared tactics and ' +
        'attendance the rest of the team can count on.',
      academyTitle: 'Academy',
      academyBody:
        'Where new recruits start. You train with the clan, play in the same voice channels ' +
        'and move up to the main roster once you are ready.',
      cta: 'Apply to the team',
    },

    closing: {
      title: 'Join the community',
      body:
        'Join the Discord and say hello. That is all it takes. If you want a place in the ' +
        'competitive roster, applications run on our recruitment site.',
    },
  },

  // ── turksletloose.com/calculator (public mortar / howitzer calculator) ───────
  calculator: {
    pageTitle: 'Mortar calculator',
    // Short label for the top bar and the footer.
    navLabel: 'Calculator',
    title: 'Mortar calculator',
    kicker: 'WARDOGS MORTAR CALCULATIONS',
    lead:
      'Put your battery and your target on the map, then read off the bearing and the ' +
      'elevation. Covers the L81 mortar and the SPH-2.',
    weapon: 'Weapon',
    map: 'Map',
    placeHint:
      'Click the map to move the highlighted point, or drag either marker. Scroll to zoom.',
    placing: 'placing',
    battery: 'Battery',
    target: 'Target',
    copy: 'Copy coordinates',
    copied: 'copied',
    paste: 'Paste coordinates',
    pasted: 'pasted',
    invalid: 'unreadable',
    copyPrompt: 'Copy these coordinates:',
    pastePrompt: 'Paste coordinates:',
    elevation: 'Elevation',
    mil: 'mil',
    lowArc: 'Low arc',
    highArc: 'High arc',
    noSolution: 'No firing solution at this distance.',
    outOfRangeNote: 'The target is out of range for this weapon.',
    distance: 'Distance',
    azimuth: 'Bearing',
    range: 'Range',
    offset: 'Offset E / N (m)',
    // Two halves of one ground selector, so each is a mode name, not a verb.
    viewTactical: 'Tactical',
    viewSatellite: 'Satellite',
    reset: 'Reset points',
    loading: 'Loading the map…',
    mapsUnavailable:
      'The map catalogue could not be loaded, so the calculator cannot be drawn. ' +
      'Try again in a moment.',
    credit: 'Ballistics tables and map calibration come from the open-source',
    creditTail: ' project (MIT).',
    hoverHint: 'move the cursor over the map',
    // Map key. Two circles, two different meanings — colour alone will not say
    // which is which.
    legendRange: 'Max range',
    legendDead: 'Dead zone',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    fitMap: 'Fit the map',
  },

  // ── turksletloose.com/supporter (supporter membership product page) ───────────
  supporter: {
    pageTitle: 'Supporter Membership',
    navLabel: 'Supporter',
    // Short bar labels — the section headings themselves ("Before you
    // subscribe") wrap onto a second line inside the 68px bar.
    navPerks: 'Perks',
    navHow: 'How it works',
    navNotes: 'Notes',
    kicker: 'MONTHLY MEMBERSHIP',
    title: 'Supporter Membership',
    lead:
      'A monthly membership for anyone who wants to back the community. What you pay ' +
      'goes straight into the cost of running our servers.',

    perksTitle: 'What you get',
    perk1Title: 'Supporter badge and colour on Discord',
    perk1Body: 'You show up in the member list with your own colour and a supporter badge.',
    perk2Title: 'Priority access on our game server',
    perk2Body: 'When the server is full you get in without waiting in the queue.',
    perk3Title: 'Supporter-only Discord channel',
    perk3Body: 'A private channel that only supporters can see and post in.',
    perk4Title: 'Priority on support tickets',
    perk4Body: 'Your ticket moves to the front of the queue and staff get to you first.',
    perkServerNote: 'Applies once our game server opens.',

    // ── Launch offer: the free trial on the Whop plan ────────────────────
    // Neither the day count nor the end date is typed into these strings:
    // both come from lib/launchOffer.ts through {n} and {date}, so the offer
    // has one source and cannot expire in one language before the other.
    launch: {
      badge: 'LAUNCH OFFER',
      title: 'The first {n} days are on us',
      body:
        'Our game server is opening, and the first {n} days are on us: subscribe now and you ' +
        'pay nothing until they are up. The badge, the channel and the queue priority all start ' +
        'straight away.',
      deadline: 'Offer runs until {date}.',
      priceNote:
        'The first {n} days are on us. Billing starts when they are up, and you can cancel ' +
        'before it does.',
    },

    priceAmount: '199 TL',
    pricePeriod: 'per month',
    priceNote: 'Renews monthly. Cancel whenever you like.',
    // Parked for the launch campaign: the panel that printed these is
    // commented out in SupporterMembership. Kept so it can go straight back.
    giftTitle: 'Gift a friend their first month',
    giftBody:
      'Your membership comes with a second server slot for one month. Enter your ' +
      'friend\'s SteamID64 at checkout and priority access is set up for them too.',
    giftNote:
      'The gift runs for one month and covers server priority only. The Discord ' +
      'badge, colour and private channel stay with you.',
    cta: 'Become a supporter',
    ctaNote: 'Payment is handled securely by Whop.',
    ctaPending: 'Checkout is being set up and opens shortly.',

    howTitle: 'How it works',
    step1Title: 'Subscribe',
    step1Body: 'Payment goes through Whop. We never see or store your card details.',
    step2Title: 'Your role lands on Discord',
    step2Body: 'The supporter role is added to your Discord account, and the badge and channels come with it.',
    step3Title: 'Your contribution keeps the lights on',
    step3Body: 'The money is spent on the server and the infrastructure around it, nothing else.',

    notesTitle: 'Before you subscribe',
    note1Title: 'You need a Discord account',
    note1Body: 'The perks are handed out on Discord, so you have to be in our server first.',
    note2Title: 'Cancel any time',
    note2Body: 'The membership renews monthly. If you cancel, your perks stay until the end of the period you paid for.',
    note3Title: 'Something wrong?',
    note3Body: 'Open a support ticket on Discord and we will sort it out.',

    backHome: 'Home',

    // ── /supporter/thanks — where Whop drops the buyer afterwards ────────────
    // Five states, because coming back here is not proof of anything: the page
    // reads the membership itself and says which of the five it found.
    ret: {
      pageTitle: 'Your membership',
      demoBadge: 'DEMO: this state is forced by the address, nothing was read',

      checkingTitle: 'Checking your payment',
      checkingBody: 'We are checking your membership. This takes a few seconds…',

      successTitle: 'Thank you for your support',
      successBody:
        'Your payment went through. You are a supporter of our server now, and we take ' +
        'it from here.',
      successBody2:
        'Staff have been notified. Priority access will be added to your Steam account ' +
        'within a few minutes.',
      successStep1Title: 'Your Discord role',
      successStep1Body: 'The supporter role lands on your Discord account within a few minutes, and the badge, colour and private channel come with it.',
      successStep2Title: 'Your server priority',
      successStep2Body: 'Staff will add priority access to your Steam account within a few minutes.',
      successStep3Title: 'Your membership',
      successStep3Body: 'You will find the renewal date and the cancel button on your profile.',
      successNote: 'If your role or your priority access has not arrived within a few minutes, please open a support ticket on Discord.',
      goProfile: 'Go to your profile',

      pendingTitle: 'We cannot see your payment yet',
      pendingBody:
        'If it went through, the membership usually shows up within a few minutes. ' +
        'Nothing is lost. Check again in a moment.',
      pendingNote: 'Still nothing after a few minutes? Open a support ticket on Discord and we will set it up by hand.',
      recheck: 'Check again',

      failedTitle: 'The payment was not completed',
      failedBody:
        'The checkout was closed or the payment did not go through. Nothing was ' +
        'charged to you.',
      failedNote: 'Seeing this page even though your card was charged? Open a support ticket on Discord.',
      retry: 'Try again',

      signedOutTitle: 'Sign in to see your membership',
      signedOutBody: 'We identify a membership by the Discord account that bought it, so we need you signed in.',
    },

    // Signed-in supporter flow (see T.profile for the profile page itself)
    ctaSignIn: 'Sign in with Discord',
    ctaLinkSteam: 'Link your Steam account',
    ctaSignInNote: 'Sign in first. Your Discord account is where the perks land.',
    ctaLinkSteamNote: 'Link Steam first: the server slot is granted to a SteamID64.',
    ctaAlreadySupporter: 'You are already a supporter',
    ctaAlreadyNote: 'Manage your membership from your profile.',
    ctaError: 'Checkout could not be opened. Try again in a moment.',
  },

  // ── turksletloose.com/profile ────────────────────────────────────────────────
  profile: {
    pageTitle: 'Profile',
    navLabel: 'Profile',
    title: 'Your profile',
    lead: 'Your Discord account, your Steam link and your supporter membership.',
    signIn: 'Sign in with Discord',
    // Shorter label for the bar, where the Discord mark already says how.
    navSignIn: 'Sign in',
    signOut: 'Sign out',
    signedOutTitle: 'Sign in to see your profile',
    signedOutBody: 'Signing in with Discord shows your Steam link and membership here.',
    loading: 'Loading…',

    discordTitle: 'Discord account',
    discordNote: 'Perks are delivered to this account.',

    steamTitle: 'Steam account',
    steamNone: 'No Steam account linked yet.',
    steamWhy: 'The server grants priority access to a SteamID64, so we need a verified one.',
    steamLink: 'Link Steam account',
    steamRelink: 'Link a different account',
    steamUnlink: 'Unlink',
    steamVerified: 'Verified through Steam',
    steamUnverified: 'Entered by staff. Link it yourself to verify.',
    steamNoName: 'Name unavailable',
    steamFailed: 'Steam did not confirm that sign-in. Please try again.',
    steamTaken: 'That Steam account is already linked to another Discord account.',

    supporterTitle: 'Supporter membership',
    supporterNone: 'You are not a supporter yet.',
    supporterActive: 'Active',
    supporterInactive: 'Inactive',
    supporterRenews: 'Renews on {date}',
    supporterEnds: 'Cancelled. Your perks run until {date}',
    supporterCancel: 'Cancel membership',
    supporterCancelTitle: 'Cancel your supporter membership?',
    supporterCancelBody: 'Your perks stay until {date}. After that the membership ends and you are not billed again.',
    supporterCancelBodyNoDate: 'Your perks stay until the end of the period you have already paid for. After that the membership ends and you are not billed again.',
    supporterCancelConfirm: 'Yes, cancel',
    supporterCancelKeep: 'Keep it',
    supporterCancelError: 'Whop could not be reached. Nothing was cancelled, please try again.',
    supporterCancelBlocked: 'Cancelling is unavailable right now. Message us on Discord and we will take care of it.',
    supporterResume: 'Resume membership',
    supporterResumeNote: 'You can undo this until {date}.',
    supporterResumeError: 'Whop could not be reached. The cancellation still stands, please try again.',
    supporterResumeBlocked: 'Resuming is unavailable right now. Message us on Discord and we will take care of it.',
    supporterBilling: 'Receipts and payment method',
    supporterCta: 'Become a supporter',
    supporterUnavailable: 'Membership status could not be read right now.',
  },

  join: {
    brand: 'Turks Let Loose',
    tagline: 'Wardogs · Competitive Clan',
    homeLink: 'Home',
    pageTitle: 'Join Us',
    heroKicker: 'RECRUITMENT OPEN',
    heroTitle: 'Join us.',
    heroLead:
      'Join one of the leading competitive teams in Wardogs. Come to the training ' +
      'nights, play matches across Europe.',
    applyCta: 'Apply with Discord',
    discordCta: 'Discord',
    continueCta: 'Continue your application',
    scrollHint: 'How it works',

    pillars: {
      title: 'What you are joining',
      communityTitle: 'A close group',
      communityBody: 'You play with people you actually know. The Discord stays busy outside match nights too.',
      matchesTitle: 'Competitive matches',
      matchesBody: 'Scrims and tournaments against organised European clans.',
      drillsTitle: 'Regular training',
      drillsBody: 'Training nights on a schedule. New tactics, position work, repetition.',
      academyTitle: 'Academy track',
      academyBody: 'New recruits start in the academy and move up to the main roster once they are ready.',
    },

    requirements: {
      title: 'What we expect from you',
      age: '18 or older.',
      mic: 'A working microphone and the willingness to use it properly.',
      experience: 'Enough Wardogs experience to know your role.',
      attendance: 'Active attendance at matches and training nights.',
      steam: 'A Steam account you can sign in to. Your SteamID64 is verified through Steam.',
    },

    steps: {
      title: 'How it works',
      one: 'Sign in with Discord',
      oneBody: 'We only read your username and avatar, nothing else.',
      two: 'Connect your Steam account',
      twoBody: 'One sign-in through Steam. Your SteamID64 is recorded as verified, not typed.',
      three: 'Fill in the form',
      threeBody: 'A couple of minutes. In-game name, age and how much you have played.',
      four: 'Your channel opens',
      fourBody: 'A private #başvuru channel is created for you on our Discord.',
      five: 'We get back to you',
      fiveBody: 'Our staff reviews it and you get the answer by DM and in your channel.',
    },

    faq: {
      title: 'Before you apply',
      q1: 'Do I need to be in your Discord?',
      a1: 'Yes. Join the server first, because your application channel is opened there.',
      q2: 'Is match attendance mandatory?',
      a2: 'Nothing is mandatory in this team, but players are expected to stay active by joining at least one match a month.',
      q3: 'What happens if I am rejected?',
      a3: 'You get told why, and you can apply again after 30 days.',
      q4: 'Why do you want my Steam account?',
      a4:
        'The roster, the game server and our match line-ups all key on your SteamID64. ' +
        'Signing in through Steam proves the id is yours. We never see your password ' +
        'and read nothing but that id.',
    },

    footerNote: 'A community clan. Not affiliated with the game or its publisher.',
    copyright: '© {year} Turks Let Loose',

    errors: {
      token_failed: 'Could not reach Discord. Please try again.',
      no_token: 'Discord did not return a session. Please try again.',
      user_fetch_failed: 'Could not read your Discord profile.',
      generic: 'Something went wrong. Please try again.',
    },

    // ── /apply ─────────────────────────────────────────────────────────────
    apply: {
      title: 'Application',
      loading: 'Loading…',
      signedInAs: 'Signed in as',
      signOut: 'Sign out',
      loadError: 'Your session could not be loaded. Try signing in again.',
      signIn: 'Sign in with Discord',
      signInBody: 'Sign in with Discord to start. We only read your username and avatar.',

      // Eligibility gates
      notInGuildTitle: 'Join our Discord first',
      notInGuildBody:
        'Your application channel is opened inside our Discord server, so you need ' +
        'to be a member before you can apply.',
      openDiscord: 'Open the Discord invite',
      noInvite: 'Ask a member for an invite link, then come back to this page.',
      recheck: 'I have joined, check again',

      alreadyMemberTitle: 'You are already one of us',
      alreadyMemberBody: 'Your Discord account already carries the member role, so there is nothing to apply for.',
      alreadyAcademyTitle: 'You are already in the academy',
      alreadyAcademyBody: 'Your Discord account already carries the academy role, so a new application is not needed.',

      pendingTitle: 'Your application is under review',
      pendingBody: 'Our staff is looking at it. You will hear back by DM and in your application channel.',
      approvedTitle: 'Your application was approved',
      approvedBody: 'Welcome aboard. Everything else happens in your application channel.',
      cooldownTitle: 'You applied recently',
      cooldownBody: 'Your last application was not successful. You can apply again on {date}.',
      openChannel: 'Open my application channel',

      // Steam gate — the id is proven through Steam, never typed into the form
      steamGateTitle: 'Connect your Steam account',
      steamGateBody:
        'Before the form, we ask Steam who you are instead of asking you to type an id ' +
        'nobody can check. One sign-in is enough, and afterwards our roster carries the ' +
        'account you actually own.',
      steamConnect: 'Sign in through Steam',
      steamFailed: 'Steam did not confirm that sign-in. Please try again.',
      steamTaken: 'That Steam account is already linked to another Discord account.',
      steamVerified: 'Verified through Steam',
      steamNoName: 'Name unavailable',
      steamRelink: 'Link a different account',

      // Form
      formTitle: 'Tell us about yourself',
      formLead: 'Four fields are required. The rest helps us put you in the right roster.',
      required: 'required',
      optional: 'optional',
      ingameName: 'In-game name',
      ingameNameHint: 'Exactly as it appears in Wardogs.',
      steamAccount: 'Steam account',
      age: 'Age',
      hours: 'Wardogs hours',
      roles: 'Roles you play',
      rolesHint: 'Pick every role you are comfortable in.',
      playstyle: 'Your playstyle',
      playstyleHint: 'Some detail on the role you picked makes placing you in the roster easier. Chasing the hotzone or building FOBs? Medic or Anti-Tank?',
      previousClans: 'Previous clans',
      previousClansHint: 'Where have you played before, and why did you leave?',
      referral: 'How did you hear about us?',
      about: 'Anything else',
      aboutHint: 'Why Turks Let Loose? Anything you want the staff to know.',
      submit: 'Send application',
      submitting: 'Sending…',
      validationError: 'Please fill in every required field.',
      submitError: 'Your application could not be sent. Please try again.',

      // Success
      successTitle: 'Application sent',
      successBody:
        'We opened a private channel for you on our Discord. Our staff will write to you there, ' +
        'and you can ask your own questions in the same place.',
      successDm: 'We also sent you the link by DM.',
      successNoChannel:
        'We could not open your channel automatically. Your application is saved and our staff ' +
        'will reach out to you on Discord.',
      backHome: 'Back to the home page',
    },
  },

  // ── Dashboard → Management → Supporters ──────────────────────────────────
  briefing: {
    title: 'Briefing',
    lead:
      'Pick a match and see whether the players on its posted roster and its reserves ' +
      'are in the Briefing voice channel. Refreshes every few seconds.',
    channelStatus: 'Channel status',
    refreshStatus: 'Update status',
    inChannelNow: '{n} in the channel',
    match: 'Match',
    upcoming: 'Upcoming',
    past: 'Past',
    noMatches: 'No matches in the last two weeks or ahead.',
    loadError: 'Briefing data could not be loaded.',
    statusError: 'The channel status could not be written.',
    notSynced: 'The Discord connection is still syncing, so voice presence is not known yet.',
    rosterNotPosted:
      'The roster for this match has not been posted yet. The check opens once the ' +
      'roster is sent to Discord. Only players on the roster and the reserves are checked.',
    noRosterTag: 'no roster',
    bench: 'Reserves',
    presentCount: '{here} / {total} in the channel',
    emptyRoster: 'The posted roster has nobody on it.',
    here: 'In channel',
    elsewhere: 'In {channel}',
    elsewhereUnknown: 'In another channel',
    absent: 'Not in voice',
    missing: 'Missing',
    extras: 'In the channel, not on the roster',
    filterAll: 'All',
    filterMissing: 'Missing only',
    briefingAt: 'Briefing {time}',
    matchAt: 'Match {time}',
  },
  supporters: {
    title: 'Supporters',
    lead:
      'Every supporter membership bought through Whop, mirrored here every few ' +
      'minutes. Read-only: Whop owns the subscription and its Discord app hands ' +
      'out the role. This is the list, not a control panel.',
    loading: 'Loading…',
    loadError: 'Supporters could not be loaded.',
    syncError: 'Whop could not be reached. The list is unchanged.',
    empty: 'No memberships here.',
    refresh: 'Sync with Whop',
    syncing: 'Syncing…',
    searchPlaceholder: 'Discord, Steam, e-mail, ID…',
    notConfigured:
      'No Whop API key is configured, so nothing can be read. The list stays ' +
      'empty until WHOP_API_KEY is set.',

    filters: { active: 'Active', inactive: 'Ended', all: 'All' },
    active: 'Active',
    inactive: 'Inactive',
    cancelling: 'Cancelling',
    unknownBuyer: 'Unknown buyer',
    verified: 'verified',
    unverified: 'unverified',
    noSteamName: 'Name unavailable',
    notNotified: 'Not sent yet',
    startedOn: 'Started {date}',
    renewsOn: 'renews {date}',
    openWhop: 'Open on Whop',
    rawToggle: 'Raw Whop data',
    footnote: 'Cancelled memberships stay listed. This is the whole history, not just who is paying today.',

    fields: {
      steamName: 'Steam account',
      steamId: 'SteamID64',
      product: 'Product',
      price: 'Amount',
      email: 'E-mail',
      membershipId: 'Membership ID',
      planId: 'Plan ID',
      notified: 'Staff notified',
    },
  },

  // ── Dashboard → Management → Applications ────────────────────────────────
  applications: {
    title: 'Applications',
    loading: 'Loading…',
    loadError: 'Applications could not be loaded.',
    refresh: 'Refresh',
    searchPlaceholder: 'Search applicant…',
    empty: 'No applications here yet.',
    count: '{n} applications',

    filters: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      all: 'All',
    },

    status: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },

    appliedOn: 'Applied {date}',
    reviewedBy: 'Reviewed by {name}',
    openChannel: 'Discord channel',
    noChannel: 'No channel',
    createChannel: 'Create channel',
    channelClosed: 'Channel closed',
    creatingChannel: 'Creating…',
    channelError: 'The channel could not be created.',

    steamProfile: 'Steam',
    noSteam: 'No Steam link',
    details: 'Details',
    hideDetails: 'Hide details',

    fields: {
      ingameName: 'In-game name',
      applied: 'Applied',
      age: 'Age',
      hours: 'Wardogs hours',
      playstyle: 'Playstyle',
      previousClans: 'Previous clans',
      referral: 'Heard about us via',
      about: 'Notes',
      discord: 'Discord',
    },

    approve: 'Approve',
    reject: 'Reject',
    approveTitle: 'Approve application',
    rejectTitle: 'Reject application',
    approveBody: 'The applicant is notified by DM and in their application channel.',
    rejectBody: 'The applicant is notified by DM and in their application channel.',
    grantAcademyRole: 'Give the Academy role on Discord',
    noteLabel: 'Note to the applicant',
    notePlaceholder: 'Optional. It is included in the DM.',
    rejectNotePlaceholder: 'Optional. The reason is included in the DM.',
    cancel: 'Cancel',
    confirmApprove: 'Approve',
    confirmReject: 'Reject',
    working: 'Working…',
    actionError: 'The action failed. Please try again.',
    reviewNote: 'Review note',

    delete: 'Delete',
    deleteTitle: 'Delete application',
    deleteBody: 'The application record is removed. This cannot be undone.',
    deleteChannelToo: 'Delete the Discord channel as well',
    confirmDelete: 'Delete',
  },
}

const tr: typeof en = {
  language: {
    select: 'Dil',
    en: 'English',
    tr: 'Türkçe',
  },
  login: {
    signInTitle: 'Devam etmek için giriş yap',
    discordDesc: "Dashboard'a erişmek için Discord hesabını kullan",
    continueWithDiscord: 'Discord ile Devam Et',
    securedOAuth: 'OAuth 2.0 ile güvence altında',
    errors: {
      not_member: 'Discord hesabın TLL veya TLLA üyesi değil.',
      token_failed: "Discord'a bağlanılamadı. Lütfen tekrar deneyin.",
      user_fetch_failed: 'Discord kullanıcı bilgisi alınamadı.',
      generic: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
    copyright: '© {year} baysal · Tüm hakları saklıdır',
  },
  nav: {
    dashboard: 'Kontrol Paneli',
    competitive: 'REKABETÇİ',
    members: 'Üyeler',
    matches: 'Maçlar',
    events: 'Etkinlikler',
    activity: 'Aktivite',
    calendar: 'Takvim',
    strategy: 'Strateji',
    management: 'YÖNETİM',
    applications: 'Başvurular',
    supporters: 'Destekçiler',
    briefing: 'Briefing',
    settings: 'Ayarlar',
    signOut: 'Çıkış Yap',
    profile: 'Profil',
    newBadge: 'YENİ',
  },
  roles: {
    owner: 'Lider',
    admin: 'Yönetici',
    moderator: 'Yetkili',
    strategist: 'Strateji',
    member: 'Üye',
  },
  dashboard: {
    title: 'Kontrol Paneli',
    online: 'ÇEVRİMİÇİ',
    noUsersOnline: 'Çevrimiçi üye yok',
    others: '+{n} diğer',
    comp: 'REKABETÇİ',
    totalMembers: 'TOPLAM ÜYE',
    mainTeam: 'ANA TAKIM',
    academy: 'AKADEMİ',
    inactive: 'İNAKTİF',
    inactiveHint: 'Toplam üyeye dahil değil',
    onlineInDiscord: "DİSCORD'DA ÇEVRİMİÇİ",
    upcomingEvents: 'YAKLAŞAN ETKİNLİKLER',
    noUpcomingEvents: 'Yaklaşan etkinlik yok',
    upcomingMatches: 'YAKLAŞAN MAÇLAR',
    noUpcomingMatches: 'Yaklaşan maç yok',
    recentJoins: 'KLANA SON KATILANLAR',
    noRecentJoins: 'Yakın zamanda katılan yok',
    joinedApprox: 'Yaklaşık, kayıtlarımızdan eski',
    teamActivity: 'TAKIM AKTİVİTESİ',
    personalActivity: 'KİŞİSEL AKTİVİTE',
    activityHint: 'Aktivite maça cevap vermektir: oynuyorum, yedek, kararsız ve katılmayacağım hepsi sayılır.',
    activityDetails: 'Ayrıntı',
    actRate: 'CEVAP ORANI',
    actLastN: 'son {n} maç',
    actAnswers: '{a}/{e} cevap',
    actMine: '{e} maçın {a} tanesine cevap verdin',
    actNothingYet: 'katıldığından beri kapanan maç yok',
    actNoMatches: 'Henüz kaydı kapanmış maç yok.',
    actPrimary: 'OYNUYOR',
    actBench: 'YEDEK',
    actTentative: 'KARARSIZ',
    actOut: 'KATILMIYOR',
    actOther: 'DİĞER',
    actSilent: 'Cevapsız',
    actAnswered: 'Cevap verdi',
    actBefore: 'Katılmadan önce',
    actAlways: 'üye her maça cevap verdi',
    actNever: 'üye hiç cevap vermedi',
    actStreak: 'maçtır aralıksız cevap',
    actPending: 'maç cevabını bekliyor',
    actNoPending: 'Cevabını bekleyen maç yok.',
    notifications: 'BİLDİRİMLER',
    noNotifications: 'Henüz bildirim yok',
    signedUp: 'Kayıtlısın',
    notSignedUp: 'Kayıt olmadın',
    cancelSignUp: 'Kaydı İptal Et',
    signUp: 'Kayıt Ol',
    chooseClass: 'SINIF SEÇ',
    confirm: 'Onayla',
    areYouSure: 'Emin misin?',
    yes: 'Evet',
    no: 'Hayır',
    viewInDiscord: "Discord'da Görüntüle",
    confirmDecline: 'Onayla / Reddet',
    new: 'YENİ',
    rosterPlacement: 'ROSTER YERLEŞİMİ',
    rosterPlacementDesc: "Bir roster pozisyonuna yerleştirildiniz. Lütfen onaylayın veya reddedin.",
    benchPlacementDesc: "Yedek olarak atandın. Lütfen onayla ya da reddet.",
    strategyPosted: 'STRATEJİ',
    strategyPostedDesc: 'Maçın stratejisi yayınlandı: {name}.',
    signupReminder: 'KAYIT',
    signupReminderDesc: 'Kadro yakında hazırlanacak. Mevkini seç ya da katılmayacağını belirt.',
    rosterUpdate: 'ROSTER GÜNCELLEMESİ',
    rosterAddedDesc: "Roster'a eklendiniz. Lütfen onaylayın veya reddedin.",
    rosterMovedDesc: "Roster pozisyonunuz değiştirildi. Lütfen onaylayın veya reddedin.",
    rosterRemovedDesc: "Roster'dan çıkarıldınız.",
    rosterUpdatedDesc: "Roster'ınız güncellendi. Lütfen onaylayın veya reddedin.",
    newMatch: 'YENİ MAÇ',
    notSignedUpYet: 'Henüz kayıt olmadınız.',
    goToEvent: 'Etkinliğe git',
    justNow: 'az önce',
    mAgo: '{n}d önce',
    hAgo: '{n}sa önce',
    dAgo: '{n}g önce',
  },
  members: {
    title: 'Üyeler',
    searchPlaceholder: 'Üye ara...',
    loading: 'Yükleniyor…',
    count: '{n} üye',
    exportMembers: 'Üyeleri Dışa Aktar',
    refresh: 'Yenile',
    serverError: 'Sunucuya erişilemedi.',
    noMembers: 'TLL veya TLLA rolüne sahip üye bulunamadı.',
    tllSection: 'TLL · {n} üye',
    tllaSection: 'TLLA · {n} üye',
    online: 'Şu an çevrimiçi',
    lastSeen: 'Son görülme: {t}',
    never: 'Hiç',
    justNow: 'Az önce',
    mAgo: '{n}d önce',
    hAgo: '{n}sa önce',
    dAgo: '{n}g önce',
    moAgo: '{n}ay önce',
    playtimeHours: '{n} sa',
    playtimeMinutes: '{n} dk',
    playtimeTotal: 'Toplam',
    playtimeFortnight: '2 hf',
    playtimeTotalHint: 'Toplam WARDOGS süresi, Steam\'den.',
    playtimeFortnightHint: 'Son 2 haftada oynanan WARDOGS süresi, Steam\'den.',
    playtimePrivate: 'Gizli',
    playtimePrivateHint: 'Bu Steam profilinde oyun ayrıntıları gizli, oyun süresi okunamıyor.',
    playtimeTotalColumn: 'WARDOGS saati (toplam)',
    playtimeFortnightColumn: 'WARDOGS saati (2 hafta)',
    sortLabel: 'Sırala',
    sortBy: {
      name: 'Ad',
      lastSeen: 'Son görülme',
      playtimeTotal: 'Toplam süre',
      playtimeFortnight: 'Süre (2 hafta)',
      clanJoined: 'Klana katılım',
    },
    sortAsc: 'Artan, çevirmek için tıkla',
    sortDesc: 'Azalan, çevirmek için tıkla',
    onlineShort: 'Çevrimiçi',
    noMatches: 'Bu aramaya uyan üye yok.',
    showDetails: 'Ayrıntıları göster',
    hideDetails: 'Ayrıntıları gizle',
    detailDiscord: 'Discord',
    detailLastSeen: 'Son görülme',
    detailJoined: 'Klana katılım',
    detailPlaytime: 'WARDOGS süresi',
    detailSteam: 'Steam',
    positions: {
      label: 'Pozisyonlar',
      mine: 'Oynamak istediğin pozisyonlar',
      mineHint: 'İstediğin kadar seçebilirsin. Üyeler listesinde adının yanında görünür.',
      noOptions: 'Henüz pozisyon tanımlanmamış.',
      specsHint: 'Alt sınıflar isteğe bağlı. Her pozisyonda oynamak istediklerini seç.',
      saveError: 'Pozisyonların kaydedilemedi. Tekrar dene.',
      filterAll: 'Tümü',
      filterNone: 'Seçmemiş',
      filterLabel: 'Pozisyona göre süz',
      none: 'Seçmemiş',
      column: 'Pozisyonlar',
    },
    cancel: 'İptal',
    save: 'Kaydet',
    ownerLocked: 'Lider · kilitli',
    role: 'Rol',
    steamVerified: 'Steam üzerinden doğrulandı',
    steamUnverified: 'doğrulanmadı',
    steamNotLinked: 'Steam bağlı değil',
    steamAccount: 'Steam hesabı',
    // Bağlı ama Steam ad vermedi (gizli profil, sorgu başarısız).
    steamNoName: 'Ad alınamadı',
    steamOpenProfile: 'Steam profilini aç',
    steamLinkTitle: 'Steam hesabını bağla',
    steamLinkBody: "Sunucu önceliği SteamID64'e tanımlanıyor, bu yüzden sahibi olduğunu kanıtladığın bir hesap gerekiyor.",
    steamLinkCta: 'Steam hesabını bağla',
    steamRelinkCta: 'Başka bir hesap bağla',
    steamUnlinkCta: 'Bağlantıyı kaldır',
    steamLinkedToast: 'Steam hesabı bağlandı.',
    steamFailedToast: 'Steam bu girişi doğrulamadı. Lütfen tekrar dene.',
    steamTakenToast: 'Bu Steam hesabı başka bir Discord hesabına bağlı.',
    manage: {
      open: 'Yönetim notları ve Steam',
      staffOnly: 'Bunu yalnızca lider, yöneticiler ve yetkililer görebilir.',
      steamTitle: 'SteamID64',
      steamPlaceholder: '7656119… ya da steamcommunity.com linki',
      steamSave: 'Kaydet',
      steamClear: 'Kaldır',
      steamClearConfirm: 'Bu üyenin Steam bağlantısı kaldırılsın mı?',
      steamHint: 'Elle girilen ID, üye kendisi Steam ile bağlayana kadar doğrulanmamış kalır.',
      steamSaved: 'SteamID kaydedildi.',
      steamCleared: 'Steam bağlantısı kaldırıldı.',
      steamInvalid: 'Geçerli bir SteamID64 ya da Steam profil linki değil.',
      steamTaken: 'Bu Steam hesabı başka bir üyeye bağlı.',
      steamError: 'Kaydedilemedi. Tekrar dene.',
      notesTitle: 'Notlar',
      notePlaceholder: 'Bu oyuncu hakkında not yaz… (kaydetmek için Ctrl+Enter)',
      noteAdd: 'Not ekle',
      notesEmpty: 'Henüz not yok.',
      notesLoadError: 'Notlar yüklenemedi.',
      noteSaveError: 'Not kaydedilemedi.',
      noteDelete: 'Notu sil',
      noteDeleteConfirm: 'Bu not silinsin mi?',
      noteDeleteError: 'Not silinemedi.',
    },
    wdl: {
      title: 'Wardogs League kadrosu',
      hint: "wardogsleague.net'te takıma başvuran klan üyeleri otomatik kabul edilir. API kimseyi doğrudan ekleyemiyor, oyuncunun önce başvurması gerekiyor.",
      refresh: 'Senkronla',
      notConfigured: 'WDL_API_KEY tanımlı değil, lig senkronu kapalı.',
      unauthorized: "Wardogs League anahtarı reddedildi. WDL_API_KEY'i kontrol et.",
      unavailable: "Wardogs League'e ulaşılamadı. Son bilinen kadro gösteriliyor.",
      loadError: 'Lig kadrosu yüklenemedi.',
      stats: 'Lig kadrosunda {roster} · klanda {clan} · eksik {missing}',
      synced: '{t} senkronlandı',
      autoAcceptOff: 'Otomatik kabul kapalı (WDL_AUTO_ACCEPT=0).',
      missingTitle: 'Klanda olup kadroda olmayanlar ({n})',
      missingNone: 'Klandaki herkes lig kadrosunda.',
      pendingTitle: 'Bekleyen başvurular ({n})',
      pendingNotClan: 'klanda değil',
      accept: 'Kabul et',
      decline: 'Reddet',
      declineConfirm: "Bu başvuru Wardogs League'de reddedilsin mi?",
      respondError: 'Başvuru cevaplanamadı.',
      outsidersTitle: 'Kadroda olup klanda olmayanlar ({n})',
      acceptedTitle: 'Son otomatik kabuller',
    },
  },
  events: {
    title: 'Etkinlikler',
    loading: 'Yükleniyor…',
    count: '{n} etkinlik',
    refresh: 'Yenile',
    noEvents: 'Etkinlik bulunamadı.',
    loadingEvents: 'Etkinlikler yükleniyor…',
    selectEvent: 'Detayları görmek için bir etkinlik seçin',
    backToEvents: '← Etkinliklere dön',
    backToDetails: '← Detaylara dön',
    signedUp: 'Kayıtlısın',
    notSignedUp: 'Kaydolmadın',
  },
  matches: {
    title: 'Maçlar',
    header: 'MAÇLAR',
    loading: 'Yükleniyor…',
    noMatches: 'Maç bulunamadı.',
    serverError: 'Sunucuya erişilemedi.',
    newMatch: 'Yeni maç',
    createMatch: 'Maç oluştur',
    editMatch: 'Maçı düzenle',
    deleteConfirm: 'Bu maç silinsin mi? Discord gönderisi de kaldırılır.',
    formTitle: 'Başlık',
    formTitlePh: 'örn. TLL vs WDUK vs 331',
    formTeams: 'Takımlar',
    formTeamPh: '{n}. takım',
    formFactionNone: 'Taraf',
    formDate: 'Tarih',
    formTime: 'Maç saati',
    formBriefing: 'Briefing',
    briefing: 'Briefing',
    kickoff: 'Maç',
    notSetYet: 'Henüz belli değil',
    staffOnly: 'Yalnızca yönetim',
    formMap: 'Harita',
    formMapNone: 'Henüz belli değil',
    formDescription: 'Açıklama',
    formDescriptionPh: 'İsteğe bağlı: rakip, kurallar…',
    formRequired: 'Başlık, tarih ve saat zorunludur.',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    cancel: 'Vazgeç',
    saveError: 'Maç kaydedilemedi.',
    postedToForum: "Discord'da kendi kanalı açılır: kayıt, kadro, strateji.",
    strategyTitle: 'Strateji',
    strategyNotPublished: 'Henüz strateji yayınlanmadı.',
    strategyNoneLinked: 'Bu maça bağlı bir strateji yok.',
    strategyOpenLibrary: 'Kütüphaneden aç',
    strategyPublish: "Discord'da yayınla",
    strategyUpdate: "Discord'da güncelle",
    strategyUnpublish: 'Yayından kaldır',
    strategyPublishHint: 'Maç kanalının 3. mesajına düşer. Bildirim yalnızca yayınlanmış kadroya yerleşen oyunculara gider.',
    strategyPublished: 'Yayınlandı.',
    strategyPublishedNotified: 'Yayınlandı. {n} oyuncuya bildirim gitti.',
    strategyUnpublished: 'Yayından kaldırıldı.',
    strategyError: 'Strateji yayınlanamadı.',
    strategySlides: '{n} slayt',
    stepSignup: 'Kayıt',
    stepPosition: 'Pozisyon',
    stepStrategy: 'Strateji',
    yourTurn: 'Sıra sende',
    stepSignupDone: '{class} olarak kayıtlısın',
    stepSignupTodo: 'Henüz kayıt olmadın',
    stepSignupNone: 'Kayıt olmadın',
    stepPositionWaiting: 'Kadro henüz yayınlanmadı',
    stepPositionOut: 'Kadroda değilsin',
    stepPositionBench: 'Yedektesin',
    stepStrategyWaiting: 'Henüz yayınlanmadı',
    openChannel: 'Maç kanalı',
    yourSignUp: 'Kaydın',
    yourPosition: 'Pozisyonun',
    signUpsTitle: 'Kayıtlılar',
    playingCount: '{n} oyuncu',
    benchCount: '{n} yedek',
    noSignUpsYet: 'Henüz kimse kayıt olmadı.',
    reminderTitle: 'Karar bekleyenler',
    reminderCount: '{n} üye',
    reminderHint: 'Hatırlatma aşağıdaki herkese DM ve panel bildirimi gönderir, maç kanalında da etiketler; etiketler ve bildirimler kadro yayınlanınca silinir.',
    reminderGroupUndecided: 'Henüz belli değil',
    reminderGroupNone: 'Seçim yapmayanlar',
    reminderAllAnswered: 'Klandaki herkes kararını verdi.',
    reminderSend: 'Hatırlat ({n})',
    reminderConfirm: '{n} üyeye DM gitsin, kanalda etiketlensin mi?',
    reminderConfirmYes: 'Gönder',
    reminderCancel: 'Vazgeç',
    reminderSent: 'Hatırlatma {n} üyeye gönderildi.',
    reminderLast: 'Son hatırlatma {ago} · {name}',
    reminderError: 'Hatırlatma gönderilemedi.',
    agoJustNow: 'az önce',
    agoMinutes: '{n} dk önce',
    agoHours: '{n} sa önce',
    agoDays: '{n} gün önce',
    positionEmpty: 'boş',
    editRoster: 'Kadroyu düzenle',
    buildRoster: 'Kadroyu kur',
    rosterWaitingHint: 'Yönetim kadroyu yayınlayınca takımın ve rolün burada görünür, buradan onaylarsın.',
    rosterWaitingStaff: "Kayıtlıları takımlara yerleştir, sonra kadroyu Discord'a gönder. Oyunculara onay için DM gider.",
    strategyWaitingHint: 'Strateji kadrodan sonra yayınlanır; kadrodaki oyunculara DM gelir.',
    relLive: 'Oynanıyor',
    relPlayed: 'Oynandı',
    relMinutes: '{n} dk sonra',
    relHours: '{n} saat sonra',
    relTomorrow: 'Yarın',
    relDays: '{n} gün sonra',
    listConfirm: 'Pozisyonunu onayla',
    listSignUp: 'Kayıt ol',
    listBench: 'Yedektesin',
    listInRoster: 'Kadrodasın',
    listDeclined: 'Pozisyonu reddettin',
    listSigned: 'Kayıtlısın · {class}',
    upcomingTitle: 'Yaklaşan',
    pastTitle: 'Geçmiş maçlar',
    refresh: 'Yenile',
    noUpcoming: 'Yaklaşan maç yok.',
    noUpcomingStaff: 'Yeni maç ile bir tane aç.',
    noUpcomingMember: 'Yeni maç açılınca DM ile haber alırsın.',
    noMatchSelectedHint: 'Soldan bir maç seç: kayıt ol, pozisyonunu gör, stratejiyi oku.',
    signedUp: 'Kayıtlısın',
    notSignedUp: 'Kayıt olmadın',
    external: 'Dış',
    history: 'GEÇMİŞ',
    showHistory: 'Maç geçmişini göster',
    hideHistory: 'Maç geçmişini gizle',
    backToList: '← Maç listesine dön',
    configureRoster: 'Roster Yapılandır',
    backToDetails: '← Detaylara dön',
    viewInDiscord: "Discord'da Görüntüle",
    noMatchSelected: 'Detayları görmek için bir maç seçin',
    matchGone: 'Bu maç artık burada değil',
    matchGoneHint: 'Link silinmiş ya da senin göremediğin bir maça gidiyor. Soldan başka bir maç seç.',
  },
  settings: {
    title: 'Ayarlar',
    squadPresets: 'Takım Ön Ayarları',
    squadPresetsDesc: 'Strateji editörü işaretçi özelliklerinde görünen takım ön ayarlarını yönetin. Bu ön ayarlar, işaretçilere takım atarken tüm kullanıcılar tarafından kullanılabilir.',
    noSquadPresets: 'Henüz takım ön ayarı yok. Aşağıdan ekleyin.',
    newSquadName: 'Yeni takım adı...',
    add: 'Ekle',
    vehiclePresets: 'Araç Ön Ayarları',
    vehiclePresetsDesc: "Strateji editöründe ok özellikleri tarafından kullanılan araç ön ayarlarını yönetin. Her ön ayarın bir adı ve hızı (km/s) vardır.",
    noVehiclePresets: 'Henüz araç ön ayarı yok. Aşağıdan ekleyin.',
    newVehicleName: 'Yeni araç adı...',
    speed: 'Hız',
    matchClasses: 'Takım Düzeni',
    matchClassesDesc: 'Dashboard maçlarında oyuncuların kaydolduğu mevkiler. Buradaki sıra oyuncuların gördüğü sıradır: seçicide, Discord menüsünde ve maç kanalında. Yalnızca admin ekibi değiştirebilir.',
    rosterDefault: 'Varsayılan Kadro',
    rosterDefaultDesc: 'Bir maçın kadro ekranı bu takım düzeniyle açılır. Kadrosu zaten kaydedilmiş maç kendi düzenini korur. Yalnızca admin ekibi değiştirebilir.',
    rosterDefaultSummary: '{squads} takım · {slots} slot',
    rosterDefaultEmpty: 'Henüz takım yok, maç kadroları boş açılır. Aşağıdan takım ekle.',
    rosterDefaultNamePh: 'Takım adı',
    rosterDefaultAdd: 'Takım ekle:',
    rosterDefaultSave: 'Kaydet',
    rosterDefaultSaving: 'Kaydediliyor…',
    rosterDefaultSaved: 'Kaydedildi',
    rosterDefaultSaveError: 'Varsayılan kadro kaydedilemedi.',
    rosterDefaultUnknownType: 'Bu takım türü artık yok. Takımı sil.',
    rosterRoles: 'Kadro Rolleri',
    rosterRolesDesc: 'Kadrodaki bir slotun alabileceği roller ve her birinin Discord emojisi. Emoji kadro ekranında, maç detayında ve Discord kadro gönderisinde görünür. Oyuncuya sağ tıklayınca ek rol olarak da bunlar çıkar.',
    rosterRolesEmpty: 'Henüz rol yok.',
    rosterRoleNamePh: 'Rol adı',
    rosterRoleUsedBy: '{n} takım türünde',
    rosterAdd: 'Ekle',
    rosterCatalogDiscard: 'Değişiklikleri geri al',
    rosterCatalogSaveError: 'Roller ve takım türleri kaydedilemedi.',
    squadTypes: 'Takım Türleri',
    squadTypesDesc: 'Kadroda hangi tür takımlar olabileceği ve hangi rollerle dolduğu. En az / en çok rol başına slot sınırıdır; varsayılan, yeni eklenen takımın kaç slotla başlayacağıdır. En az = en çok ise slot sabittir. Roller ve takım türleri birlikte kaydedilir.',
    squadTypeRole: 'Rol',
    squadTypeMin: 'En az',
    squadTypeDefault: 'Varsayılan',
    squadTypeMax: 'En çok',
    squadTypeAddRule: 'Rol ekle',
    squadTypeNoRules: 'Rol yok. En az bir rol ekle ya da bu türü sil.',
    rosterProblemNoRoles: 'En az bir rol ekle.',
    rosterProblemRoleName: 'Adı boş bir rol var.',
    rosterProblemNoTypes: 'En az bir takım türü ekle.',
    rosterProblemTypeName: 'Adı boş bir takım türü var.',
    rosterProblemTypeNoRoles: "'{name}' türünde hiç rol yok. Rol ekle ya da türü sil.",
    squadTypeNamePh: 'Takım türü adı',
    noMatchClasses: 'Henüz mevki yok. Aşağıdan ekleyin. Hiç mevki yoksa kimse kayıt olamaz.',
    newClassName: 'Yeni mevki adı...',
    classEmoji: 'Emoji',
    emojiSearch: 'Emoji ara (İngilizce: tank, fire…)',
    emojiFromServer: 'Discord sunucumuzdan',
    emojiUnicode: 'Düz emoji',
    emojiLoading: 'Emojiler yükleniyor…',
    emojiGroups: ['İfadeler', 'İnsanlar', 'Bileşenler', 'Hayvanlar ve doğa', 'Yiyecek ve içecek', 'Seyahat ve yerler', 'Etkinlikler', 'Nesneler', 'Semboller', 'Bayraklar'],
    emojiNone: 'Sunucuda özel emoji yok.',
    emojiNoMatch: 'Eşleşen emoji yok.',
    emojiClear: 'Emojiyi kaldır',
    classKindPrimary: 'Oynuyor',
    classKindBench: 'Yedek',
    classKindTentative: 'Kararsız',
    classKindOut: 'Katılmıyor',
    classMoveUp: 'Yukarı taşı',
    classMoveDown: 'Aşağı taşı',
    classSaveError: 'Mevki kaydedilemedi.',
    classSpecs: 'Alt sınıflar',
    classSpecsHint: 'Bu mevki seçilince sorulur, dashboard\'da da Discord\'da da. İsteğe bağlıdır: alt sınıf seçmeden de kayıt olunur. Oyuncunun son seçimi, değiştirene kadar hatırlanır.',
    newSpecName: 'Yeni alt sınıf...',
    noClassSpecs: 'Alt sınıf yok: mevki tek başına seçilir.',
    removeSpec: 'Alt sınıfı kaldır',
  },
  calendar: {
    title: 'Takvim',
    days: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'],
    months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    monthsShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    noEvents: 'Bu ay etkinlik veya maç yok.',
    refresh: 'Yenile',
    today: 'Bugün',
    eventLegend: 'Etkinlik',
    matchLegend: 'Maç',
    externalMatch: 'Dış Maç',
    signedUp: 'katılımcı',
  },
  eventDetail: {
    removedClass: 'kaldırıldı',
    changeSignUp: 'Mevkini değiştir',
    changeSignUpHint: 'Yeni mevkini seç.',
    changeSignUpSave: 'Değiştir',
    removedClassHint: 'Bu mevki Ayarlar → Takım Düzeni\'nden kaldırıldı. Bu kayıtlar oyuncular yeni bir mevki seçene kadar sayılmaz.',
    yourSignUp: 'KAYIT DURUMUN',
    yourPosition: 'POZİSYONUN',
    cancelSignUp: 'Kaydı İptal Et',
    notSignedUp: 'Kayıt olmadın',
    chooseClass: 'Sınıf Seç',
    chooseSpec: 'Alt sınıf (isteğe bağlı)',
    signUp: 'Kayıt Ol',
    positionConfirmed: 'Onaylandı',
    positionDeclined: 'Reddedildi',
    confirm: 'Onayla',
    decline: 'Reddet',
    benchPosition: 'Yedek',
    benchPositionHint: 'İhtiyaç olursa bir takıma alınabilirsin.',
    declineReasonLabel: 'Neden reddediyorsun?',
    declineReasonPlaceholder: 'Maça katılamayacak mısın ya da pozisyonunu mu beğenmedin? Pozisyonunu beğenmediysen hangi pozisyonu tercih ederdin? Yönetim kadroyu buna göre yeniden kuracak.',
    declineReasonTooShort: 'Reddetmek için bir sebep yaz.',
    declineSubmit: 'Reddi gönder',
    declineReasonYours: 'Sebebin: {reason}',
    rosterNotPosted: 'Roster henüz yayınlanmadı',
    notInRoster: "Roster'da yer almıyorsun",
    signedUpSection: 'KAYITLI ({n})',
    noSignUps: 'Henüz kayıt yok',
    squadLayout: 'TAKIM DÜZENİ',
    rosterLayout: 'KADRO DÜZENİ',
    externalModify: 'Dış etkinliklerde değişiklik yapılamaz',
    externalNotAvailable: 'Dış etkinlik, kayıt mevcut değil',
    viewInDiscord: "Discord'da Görüntüle",
    signedUpCount: 'kayıtlı',
    emptySlot: 'Boş',
    confirmAction: 'Onayla',
    cancelAction: 'İptal',
    removeMatchTitle: 'Maçı kaldır',
    editMatchTitle: 'Maçı düzenle',
  },
  squadBuilder: {
    rosterConfiguration: 'ROSTER YAPILANDIRMASI',
    addMember: 'Üye Ekle',
    addSquad: 'Takım Ekle',
    saved: 'Kaydedildi',
    save: 'Kaydet',
    update: 'Güncelle',
    send: 'Gönder',
    updating: 'Güncelleniyor…',
    sending: 'Gönderiliyor…',
    updated: 'Güncellendi',
    sent: 'Gönderildi',
    updateDiscordTitle: "Discord embed'ini güncelle",
    sendDiscordTitle: 'Discord kanalına gönder',
    searchMembers: 'Üye ara…',
    noMembersFound: 'Üye bulunamadı',
    extraRoles: 'EK ROLLER',
    wantedSpec: 'Kayıt tercihi: {spec}',
    slotConfig: 'SLOT YAPILANDIRMASI',
    unassigned: 'ATANMAMIŞ ({n})',
    unassignedHint: 'Burada kalan herkes yedek olarak yayınlanır.',
    benchTag: 'Yedek',
    declinedReason: 'Reddetti: {reason}',
    search: 'Ara…',
    allAssigned: 'Tümü atandı',
    removed: 'KADRODAN ÇIKARILANLAR ({n})',
    removedEmpty: 'Kadrodan tamamen çıkarmak için oyuncuları buraya bırak',
    tentative: 'YÜZDE ELLİ',
    absent: 'GELMEYECEK',
    overview: 'ÖZET',
    total: 'Toplam',
    loading: 'Yükleniyor…',
    noSquads: '"Takım Ekle"ye tıklayarak takım oluştur',
    noSlots: 'Tanımlı slot yok',
    rightClickHint: 'Ek roller için sağ tık · Atamayı kaldırmak için çift tık',
    tapPickHint: 'Bir oyuncuya dokun, sonra bir slota ya da takıma dokunup yerleştir',
    tapPlaceHint: 'Yerleştirmek için bir slota ya da takıma dokun · geri almak için havuzlara dokun',
    tapCancel: 'Vazgeç',
    dragSquadHint: 'Takımı taşımak için sürükle',
  },
  strategyEditor: {
    collapsePanel: 'Paneli küçült',
    expandPanel: 'Paneli genişlet',
    noteAssignPlayers: 'Not & Oyuncu Ata',
    noContent: 'İçerik yok',
    note: 'Not',
    notePlaceholder: 'Bu SP için not ekle...',
    players: 'Oyuncular',
    searchMember: 'Üye ara...',
    filterPlaceholder: 'Oyuncu veya takım adı...',
    squadsSection: 'Takımlar',
    playersSection: 'Oyuncular',
    toolSelect: 'Seç',
    toolPing: 'Ping',
    toolArrow: 'Ok',
    toolCircle: 'Daire',
    toolPolygon: 'Çokgen',
    toolText: 'Metin',
    toolMarker: 'İşaretçiler',
    toolMarkerSingle: 'İşaretçi',
  },
  activity: {
    title: 'Aktivite',
    loadError: 'Sunucuya erişilemedi.',
    refresh: 'Yenile',
    daysShort: 'g',
    noMatches: 'Bu aralıkta maç yok.',

    // ── Katılım bandı ─────────────────────────────────────────────────────
    turnout: 'MAÇ KATILIMI',
    statMatches: 'MAÇ',
    statAvg: 'ORT. KATILIM',
    statBest: 'EN YÜKSEK',
    statPlayers: 'OYUNCU',
    seriesPlayed: 'Oynayan',
    seriesBenched: 'Kaydolup oynamayan',
    totalSignUps: 'Toplam kayıt',
    clickHint: 'Kadrosunu görmek için bir maça tıkla.',

    // ── Maç paneli ────────────────────────────────────────────────────────
    matchRoster: 'KADRO',
    close: 'Kapat',
    noRoster: 'Kimse kaydolmamış.',
    mapUnknown: 'Harita girilmemiş',
    externalTag: 'dış',

    // ── Sıralama ──────────────────────────────────────────────────────────
    ranking: 'KATILIM SIRALAMASI',
    searchPlayers: 'Oyuncu ara...',
    sortPlayed: 'Katılım',
    sortRate: 'Oran',
    sortRateHint: 'Oyuncu geldiğinden beri oynanan maçlardaki payı. Yeni gelen, kendinden önceki maçlardan sorumlu tutulmaz.',
    sinceJoin: '{date} tarihinden beri',
    wholeRange: 'tüm aralık',
    noPlayers: 'Eşleşen oyuncu yok.',
    you: '(sen)',

    // ── Oyuncu paneli ─────────────────────────────────────────────────────
    player: 'OYUNCU',
    selectPlayer: 'Çağrıldığı her maçı görmek için bir oyuncu seç.',
    played: 'Katılım',
    rate: 'Oran',
    streak: 'Seri',
    record: 'MAÇ BAZINDA',
    recordHint: 'Her maç bir kare, en eskisi solda.',
    history: 'GEÇMİŞ',
    backToList: '\u2190 Geri',

    // ── Oyuncunun maçtaki durumu ──────────────────────────────────────────
    statePlayed: 'Oynadı',
    stateBench: 'Yedek',
    stateOut: 'Oynamadı',
    stateAbsent: 'Kayıt yok',

    // ── İnaktifler ────────────────────────────────────────────────────────
    inactiveTitle: 'İNAKTİFLER',
    inactiveHint: 'Son {n} maçın hiçbirine cevap vermeyen üyeler. ("Pozisyon", "Henüz belli değil" ya da "Katılmayacağım" seçmeyenler)',
    inactiveNone: 'İnaktif üye yok.',
    inactiveWaiting: 'Sayım {n} maç kapandıktan sonra başlar (şu an {have}).',
    inactiveDisabled: 'Otomatik geçiş kapalı (INACTIVITY_ENABLED=0). Liste ve geri alma çalışmaya devam eder.',
    inactiveSince: '{date} tarihinden beri inaktif',
    inactiveRestore: 'Geri al',
    inactiveRestoreHint: 'Alınan takım rollerini geri verir ve inaktif rolünü kaldırır.',
    inactiveRestoreFailed: 'Roller Discord\'da geri verilemedi.',
    teamMember: 'Üye',
    teamAcademy: 'Akademi',
  },
  strategy: {
    // ── Strateji sekmesi — üç bölüm ───────────────────────────────────────
    pageTitle: 'Strateji',
    pageSubtitle: 'Maç planları, ortak taktik defteri ve haritaların nokta katmanı.',
    tabs: {
      match: 'Maç Stratejileri',
      points: 'Stratejik Noktalar',
      playbook: 'Taktik Defteri',
    },
    sectionDesc: {
      match: 'Klan maçları için çizilen planlar. Yönetim ekibi açar.',
      points: 'Her haritanın nokta katmanı: mevziler, bakış açıları, görüntüler.',
      playbook: 'Herkesin paylaştığı açık taktikler. Maç planlarıyla aynı editör.',
    },
    access: {
      staffOnly: 'Yalnızca yönetim',
      everyoneOwn: 'Herkes ekler · yalnızca kendini siler',
      everyone: 'Herkese açık',
    },
    library: {
      newMatchStrategy: 'Yeni maç stratejisi',
      newPlaybookEntry: 'Yeni taktik',
      emptyMatch: 'Henüz maç stratejisi yok.',
      emptyPlaybook: 'Defter boş. İlk taktik senin olabilir.',
      lockedMatch: 'Maç stratejisini yönetim ekibi açar.',
      search: 'Strateji ara...',
      noSearchResult: 'Eşleşen bir şey yok.',
      slideCount: '{n} slayt',
      oneSlide: '1 slayt',
      noSlides: 'Henüz slayt yok.',
      addSlide: 'Slayt ekle',
      slideName: 'Slayt {n}',
      openLabel: 'Aç',
      mine: 'Senin',
      noMapPicked: 'Önce bir harita seç.',
    },
    pointsPicker: {
      hint: 'Nokta katmanını açmak için bir harita seç.',
    },
    noMapsAvailable: 'Kullanılabilir harita yok.',
    sidebarOpen: 'Strateji listesini aç',
    sidebarClose: 'Strateji listesini kapat',
    tools: {
      select: 'Seç',
      ping: 'İşaret',
      markers: 'Simgeler',
      arrow: 'Ok',
      polygon: 'Çokgen',
      circle: 'Çember',
      text: 'Yazı',
      ruler: 'Cetvel',
      hotzone: 'Hotzone (170 m)',
    },
    home: 'Strateji ana sayfası',
    untitled: 'Adsız',
    strategicPointsToggle: 'Stratejik noktalar',
    calloutsToggle: 'Mevkiler',
    gridToggle: 'Izgara',
    rulerHint: 'Ölçmek için sürükle. Esc temizler.',
    hotzoneNote: 'Hotzone oyundaki sarıyla 170 m çaplı sabit bir çemberdir. Yalnızca taşınır.',
    filterMarkers: 'Simgeleri oyuncuya ya da takıma göre süz',
    whoIsViewing: 'Kimler bakıyor',
    you: 'sen',
    noMatchesFound: 'Eşleşme yok',
    noAssignments: 'Henüz oyuncu ya da takım atanmadı',
    pickFromSidebar: 'Kenar çubuğundan bir strateji seç',
    gone: 'Bu strateji artık burada değil',
    goneHint: 'Link silinmiş bir stratejiye gidiyor. Kenar çubuğundan başka birini seç.',
    readOnly: 'Salt okunur',
    // ── Editör kabuğu ─────────────────────────────────────────────────────
    undo: 'Geri al',
    redo: 'İleri al',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    zoomFit: 'Tüm haritayı sığdır',
    saving: 'Kaydediliyor',
    saved: 'Kaydedildi',
    actions: 'İşlemler',
    markerGroups: { tactical: 'TAKTİK', vehicles: 'ARAÇLAR', vehiclesSide: 'ARAÇLAR (YAN GÖRÜNÜM)', enemy: 'DÜŞMAN', supply: 'İKMAL' },
    team: 'TAKIM',
    teamNone: 'Beyaz',
    fobRotation: 'FOB YÖNÜ',
    fobRotateHint: 'Döndürmek için sürükle · Shift 15°’ye oturtur',
    controlZone: 'Kontrol bölgesi: o rotasyonda çarpışılan çember',
    controlZoneOff: 'Kontrol bölgesi yok',
    fillOpacity: 'DOLGU OPAKLIĞI',
    fontSize: 'YAZI BOYUTU',
    background: 'ZEMİN',
    bgNone: 'Yok',
    bgSolid: 'Düz',
    bgBubble: 'Balon',
    selectHint: 'Bir nesneye tıklayarak seç, sürükleyerek taşı. Del seçili olanı siler.',
    pingHint: 'Haritada bir yere tıkla: bu slayta bakan herkes işareti görür.',
    addToSlide: 'Slayta ekle',
    addedToSlide: 'Slaytta',
    edit: 'Düzenle',
    duplicate: 'Çoğalt',
    searchMarker: 'Simge ara...',
    strategies: 'Stratejiler',
    refresh: 'Yenile',
    newStrategy: 'Yeni Strateji',
    map: 'HARİTA',
    mapDescriptions: {
      bakurani: 'Dağlar arasında bir nehir vadisi. Vadi tabanı açık: fabrika blokları ve boydan boya uzanan yol. İki yamaç da ormana tırmanıyor. Tabandaki her şey yukarıdan görüldüğü için çatışmayı sırtları tutan taraf belirler.',
      ozeti: 'Yollar boyunca dizilmiş bir kasaba, stadyum ve tarla parsellerinden oluşan bir nehir havzası; aralarını orman dolduruyor. Parseller arasındaki açıklık, sis ya da siperli bir yaklaşma olmadan hareketi pahalıya mal ediyor.',
      zesty: 'Nehir kıvrımında bir kasaba; çevresine yayılan tarlalar ve dağınık koruluklar. Binalardan uzaklaşınca arazi açık ve kuru. Siper bulunacak bir şey değil, yanında getirilecek bir şey.',
    },
    mapView: {
      label: 'Harita görünümü',
      tactical: 'Taktiksel',
      satellite: 'Uydu',
      tacticalHint: 'Taktiksel görünüm: gri tonlama, eşitlenmiş parlaklık; marker\'lar her haritada aynı okunur',
      satelliteHint: 'Uydu görünümü: haritanın ham renkleri',
    },
    selectMap: 'Harita seçin...',
    match: 'MAÇ',
    optional: 'isteğe bağlı',
    noMatch: 'Maç yok',
    creating: 'Oluşturuluyor...',
    create: 'Oluştur',
    allStrategies: 'TÜM STRATEJİLER',
    noStrategies: 'Henüz strateji yok.',
    slides: 'SLAYTLAR',
    noSlides: 'Henüz slayt yok.',
    addSlide: 'Slayt Ekle',
    deleteSlide: 'Bu slayt silinsin mi?',
    deleteStrategy: 'Strateji ve tüm slaytlar silinsin mi?',
    delete: 'Sil',
    cancel: 'İptal',
    rename: 'Yeniden Adlandır',
    copyName: '{name} (kopya)',
    color: 'RENK',
    custom: 'ÖZEL',
    squads: 'TAKIMLAR',
    selectSquad: 'Takım seçin...',
    addSquad: 'Takım ekle...',
    members: 'ÜYELER',
    searchMember: 'Üye ara...',
    noMembersFound: 'Üye bulunamadı',
    title: 'BAŞLIK',
    titlePlaceholder: 'Başlık...',
    description: 'AÇIKLAMA',
    descriptionPlaceholder: 'Açıklama...',
    strokeWidth: 'ÇİZGİ KALINLIĞI',
    lineStyle: 'ÇİZGİ STİLİ',
    solid: 'Düz',
    dashed: 'Kesik Çizgi',
    dotted: 'Noktalı',
    arrowHead: 'OK BAŞLIĞI',
    none: 'Yok',
    arrow: 'Ok',
    flat: 'Düz Uç',
    startMarker: 'BAŞLANGIÇ İŞARETÇİSİ',
    vehicle: 'ARAÇ',
    changeVehicle: 'Aracı değiştir...',
    selectVehicle: 'Araç seçin...',
    noVehiclePresets: 'Araç ön ayarı yok. Ayarlardan ekleyin.',
  },
  // ── Stratejik Noktalar — harita başına nokta katmanı ──────────────────────
  strategicPoints: {
    title: 'Stratejik Noktalar',
    back: 'Stratejiye dön',
    countLabel: 'NOKTALAR',
    empty: 'Bu haritada henüz nokta yok.',
    noPermission: 'Bu noktayı düzenleme yetkiniz yok.',
    yours: 'Senin',
    addedBy: 'Ekleyen',
    iconTypes: {
      infantry: 'Piyade',
      tank: 'Tank',
      roof: 'Çatı',
      bush: 'Çalı',
      mg: 'Makineli',
      snipe: 'Keskin Nişancı',
      glitch: 'Hata',
      other: 'Diğer',
    },
    panel: {
      collapse: 'Paneli kapat',
      expand: 'Paneli aç',
      editPoint: 'Noktayı düzenle',
      exitEdit: 'Düzenlemeden çık',
      pointTitle: 'Stratejik nokta',
      selectTitle: 'Seç',
      icon: 'SİMGE',
      description: 'AÇIKLAMA',
      notesPlaceholder: 'Notlar...',
      viewingAngles: 'BAKIŞ AÇILARI',
      media: 'GÖRSEL',
      noMedia: 'Eklenmiş görsel yok',
      deletePoint: 'Noktayı sil',
      confirmDelete: 'Bu nokta silinsin mi?',
      delete: 'Sil',
      selectIcon: 'SİMGE SEÇ',
      selectIconHint: 'Bir simge seç, sonra haritaya tıklayıp yerleştir.',
      idleHint: 'Ayrıntılar için bir noktaya tıkla. Sağ tık daha fazlasını açar.',
    },
    draw: {
      arrow: 'Ok',
      polygon: 'Çokgen',
      arrowFrom: 'Bu noktadan ok çiz',
      polygonFrom: 'Bu noktadan çokgen çiz',
      arrowHint: 'Okun ucunu koymak için tıkla. Esc iptal eder.',
      polygonHint: 'Köşe eklemek için tıkla. Kapatmak için ilk tutamağa tıkla. Sağ tık son köşeyi geri alır, Esc iptal eder.',
    },
    media: {
      upload: 'Görsel / video yükle',
      uploading: 'Yükleniyor...',
      linkPlaceholder: 'Görsel / video bağlantısı yapıştır...',
      addLink: 'Ekle',
      linkFailed: 'Bağlantı eklenemedi.',
      deleteMedia: 'Görseli sil',
      expand: 'Büyüt',
    },
  },
  callouts: {
    title: 'Mevkiler',
    tool: 'Mevki (bölge çiz)',
    empty: 'Bu haritada henüz mevki yok.',
    toolHint: 'Bölgeyi başlatmak için haritaya tıkla. Her tıklama bir köşe ekler.',
    drawHint: 'Köşe eklemek için tıkla. Kapatmak için ilk köşeye tıkla ya da Enter. Backspace son köşeyi siler, Esc iptal eder.',
    newTitle: 'Yeni mevki',
    name: 'Ad',
    namePlaceholder: 'örn. Stadyum',
    nameHint: 'Takımın oyunda bu yere ne dediği.',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    delete: 'Mevkiyi sil',
    confirmDelete: 'Bu mevki silinsin mi?',
    editHint: 'Sınırı değiştirmek için köşeleri sürükle. Kenar ortasındaki tutamacı sürüklemek köşe ekler, köşeye çift tıklamak siler.',
    readOnly: 'Bu mevkiyi yalnızca ekleyen ve yönetim düzenleyebilir.',
    saveFailed: 'Kaydedilemedi.',
    corners: '{n} köşe',
  },
  // ── join.turksletloose.com — public recruitment site ──────────────────────
  // ── turksletloose.com (halka açık topluluk sitesi) ──────────────────────
  home: {
    pageTitle: 'Turks Let Loose',
    tagline: 'Wardogs Türk topluluğu',
    navCommunity: 'Topluluk',
    navGames: 'Oyunlar',
    navCompetitive: 'Takım',
    navSupporter: 'Destekçi',
    footerNote: 'Bir oyuncu topluluğudur. Oyunlar veya yapımcılarıyla bağlantılı değildir.',
    heroKicker: 'WARDOGS TÜRK TOPLULUĞU',
    heroTitle: 'Turks Let Loose',
    heroLead:
      "Türkiye'nin en büyük Wardogs sunucusuna ev sahipliği yapan Turks Let Loose, FPS " +
      'oyunlarını ciddiye alan ve eğlenceden ödün vermeyen bir Türk oyuncu topluluğudur. ' +
      'Wardogs başta olmak üzere rekabetçi düzeyde birçok oyun oynuyoruz. İyi bir ekiple ' +
      'oynamak istiyorsan doğru yerdesin.',
    joinCta: 'Takıma Başvur',
    discordCta: 'Discord',
    serverCardKicker: 'DISCORD SUNUCUMUZ',
    serverCardOnlineLabel: 'Çevrimiçi',
    serverCardMembersLabel: 'Üye',
    serverCardCta: "Discord'a katıl",
    discordJoinCta: "Discord'a katıl",
    dashboardLink: 'Üye paneli',

    community: {
      title: 'Topluluk',
      body:
        "Her şey Discord'umuzda dönüyor: oyun geceleri, rekabetçi maçlar ve keyfi oyunlar. " +
        'Kimse tek bir oyun için burada değil; insanlar ses kanalında kim varsa onun için ' +
        'geliyor.',
      recentTitle: 'Aramıza yeni katılanlar',
      cta: 'Sen De Katıl',
    },

    games: {
      title: 'Ne oynuyoruz',
      wardogsTitle: 'Wardogs',
      wardogsBody: 'Ana oyunumuz. Rekabetçi maçlar, eğitim geceleri ve yakında kendi sunucumuz.',
      shootersTitle: 'Diğer FPS oyunları',
      shootersBody: 'Topluluk başka FPS oyunlarında da toplanıyor. Ekip tamsa oyunun adı ikinci planda.',
      partyTitle: 'Parti oyunları',
      partyBody: 'Zaman zaman parti oyunlarıyla kafayı yiyoruz. Herkes katılabilir.',
      nightsTitle: 'Oyun geceleri',
      nightsBody: "Planlı geceler ve anlık lobiler. İkisi de Discord'da duyuruluyor.",
    },

    competitive: {
      title: 'Rekabetçi Takım',
      lead:
        'Topluluğun içinde Avrupa klanlarına karşı organize maçlara çıkan bir kadro da var. ' +
        'Bu yaptığımız işlerden biri; aramıza katılmanın şartı değil.',
      mainTitle: 'Ana kadro',
      mainBody:
        'Scrim ve turnuvalara çıkan kadro. Belirli roller, hazırlanmış taktikler ve takımın ' +
        'geri kalanının güvenebileceği bir katılım.',
      academyTitle: 'Akademi',
      academyBody:
        'Yeni gelenlerin başladığı yer. Klanla birlikte antrenman yapar, aynı ses kanallarında ' +
        'oynar ve hazır olduğunda ana kadroya yükselirsin.',
      cta: 'Takıma başvur',
    },

    closing: {
      title: 'Topluluğa dahil ol',
      body:
        "Discord'a katıl ve selam ver, tek gereken bu. Rekabetçi kadroda yer almak istiyorsan " +
        'başvurular katılım sitemizden ilerliyor.',
    },
  },

  // ── turksletloose.com/calculator (halka açık havan hesabı) ───────────────────
  calculator: {
    pageTitle: 'Havan hesabı',
    navLabel: 'Havan Hesabı',
    title: 'Havan hesabı',
    kicker: 'WARDOGS HAVAN TOPU HESAPLAMA',
    lead:
      'Bataryanı ve hedefi haritaya koy, açıyı ve yükselişi oku. L81 havan ile SPH-2 ' +
      'için çalışır.',
    weapon: 'Silah',
    map: 'Harita',
    placeHint:
      'Seçili noktayı taşımak için haritaya tıkla, ya da işaretçiyi sürükle. ' +
      'Yakınlaştırmak için tekerlek.',
    placing: 'yerleştiriliyor',
    battery: 'Batarya',
    target: 'Hedef',
    copy: 'Koordinatı kopyala',
    copied: 'kopyalandı',
    paste: 'Koordinatı yapıştır',
    pasted: 'yapıştırıldı',
    invalid: 'okunamadı',
    copyPrompt: 'Koordinatı kopyala:',
    pastePrompt: 'Koordinatı yapıştır:',
    elevation: 'Yükseliş',
    mil: 'mil',
    lowArc: 'Düz yay',
    highArc: 'Dik yay',
    noSolution: 'Bu mesafede atış çözümü yok.',
    outOfRangeNote: 'Hedef bu silahın menzili dışında.',
    distance: 'Mesafe',
    azimuth: 'Açı',
    range: 'Menzil',
    offset: 'Fark D / K (m)',
    viewTactical: 'Taktiksel',
    viewSatellite: 'Uydu',
    reset: 'Noktaları sıfırla',
    loading: 'Harita yükleniyor…',
    mapsUnavailable:
      'Harita kataloğu alınamadı, hesap makinesi çizilemiyor. Biraz sonra tekrar dene.',
    credit: 'Balistik tablolar ve harita kalibrasyonu açık kaynak',
    creditTail: ' projesinden alındı (MIT).',
    hoverHint: 'imleci haritanın üzerine getir',
    legendRange: 'Azami menzil',
    legendDead: 'Ölü bölge',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    fitMap: 'Haritayı sığdır',
  },

  // ── turksletloose.com/supporter (destekçi üyeliği ürün sayfası) ───────────────
  supporter: {
    pageTitle: 'Destekçi Üyeliği',
    navLabel: 'Destekçi',
    navPerks: 'Ayrıcalıklar',
    navHow: 'Nasıl çalışır',
    navNotes: 'Notlar',
    kicker: 'AYLIK ÜYELİK',
    title: 'Destekçi Üyeliği',
    lead:
      'Topluluğumuzu desteklemek isteyenler için aylık üyelik. Ödediğin tutar doğrudan ' +
      'sunucu maliyetlerine katkı sağlar.',

    perksTitle: 'Neler kazanıyorsun',
    perk1Title: "Discord'da özel Destekçi rozeti ve rengi",
    perk1Body: 'Üye listesinde kendi rengin ve destekçi rozetinle görünürsün.',
    perk2Title: 'Oyun sunucumuza öncelikli giriş',
    perk2Body: 'Sunucu doluyken sırada beklemeden girersin.',
    perk3Title: "Destekçilere özel Discord kanalı",
    perk3Body: 'Yalnızca destekçilerin görüp yazabildiği özel bir kanal.',
    perk4Title: 'Destek taleplerinde öncelik',
    perk4Body: "Açtığın destek ticket'ı sıranın başına geçer, yönetim önce sana döner.",
    perkServerNote: 'Oyun sunucumuz açıldığında geçerli olacak.',

    // ── Açılışa özel teklif: Whop planındaki ücretsiz deneme ─────────────
    // Ne gün sayısı ne de son tarih bu metinlere yazılır; ikisi de
    // lib/launchOffer.ts'ten {n} ve {date} ile gelir — teklifin tek bir
    // kaynağı olsun, bir dilde bitip diğerinde sürmesin.
    launch: {
      badge: 'AÇILIŞA ÖZEL',
      title: 'İlk {n} gün hediyemiz',
      body:
        'Oyun sunucumuz açılıyor ve ilk {n} gün bizden: şimdi abone olursan bu süre boyunca ' +
        'ücret alınmaz. Rozet, özel kanal ve giriş önceliği ilk günden başlar.',
      deadline: '{date} tarihine kadar geçerli.',
      priceNote:
        'İlk {n} gün hediyemiz. Ödeme bu süre bitince başlar, bitmeden istediğin zaman iptal ' +
        'edebilirsin.',
    },

    priceAmount: '199 TL',
    pricePeriod: 'aylık',
    priceNote: 'Her ay yenilenir. İstediğin zaman iptal edebilirsin.',
    // Açılış kampanyası boyunca park edildi: bunları basan panel
    // SupporterMembership'te kaldırıldı. Geri konabilsin diye duruyorlar.
    giftTitle: 'Bir arkadaşına ilk ay hediye',
    giftBody:
      'Üyeliğin bir aylığına ikinci bir sunucu slotuyla geliyor. Ödeme sırasında ' +
      "arkadaşının SteamID64'ünü gir, öncelikli giriş ona da tanımlansın.",
    giftNote:
      'Hediye bir ay sürer ve yalnızca sunucu önceliğini kapsar; Discord rozeti, ' +
      'renk ve özel kanal sende kalır.',
    cta: 'Destekçi Ol',
    ctaNote: 'Ödeme güvenli şekilde Whop üzerinden alınır.',
    ctaPending: 'Ödeme sayfası hazırlanıyor, çok yakında açılıyor.',

    howTitle: 'Nasıl işliyor',
    step1Title: 'Abone ol',
    step1Body: 'Ödeme Whop üzerinden alınır. Kart bilgilerin bize hiç ulaşmaz.',
    step2Title: "Rolün Discord'da tanımlanır",
    step2Body: 'Destekçi rolü Discord hesabına eklenir; rozet ve özel kanallar onunla birlikte açılır.',
    step3Title: 'Katkın sunucuda kalır',
    step3Body: 'Toplanan tutar sunucu ve altyapı giderlerine harcanır, başka bir yere gitmez.',

    notesTitle: 'Abone olmadan önce',
    note1Title: 'Discord hesabın gerekli',
    note1Body: 'Ayrıcalıklar Discord üzerinden veriliyor, bu yüzden önce sunucumuzda olman gerekiyor.',
    note2Title: 'İstediğin zaman iptal',
    note2Body: 'Üyelik aylık yenilenir. İptal edersen ödediğin dönemin sonuna kadar ayrıcalıkların devam eder.',
    note3Title: 'Bir sorun mu var?',
    note3Body: "Discord'da destek talebi açman yeterli, hallederiz.",

    backHome: 'Ana sayfa',

    // ── /supporter/thanks — Whop ödemeden sonra alıcıyı buraya bırakır ───────
    // Beş durum, çünkü buraya düşmek hiçbir şeyin kanıtı değil: sayfa üyeliği
    // kendisi okur ve beşinden hangisini bulduysa onu söyler.
    ret: {
      pageTitle: 'Üyeliğin',
      demoBadge: 'DEMO: bu durum adresten zorlandı, hiçbir şey okunmadı',

      checkingTitle: 'Ödemen kontrol ediliyor',
      checkingBody: 'Üyeliğini kontrol ediyoruz. Birkaç saniye sürüyor…',

      successTitle: 'Desteğin için teşekkürler',
      successBody:
        'Ödemen alındı. Artık sunucumuzun destekçisisin. Bundan sonrasını biz ' +
        'hallediyoruz.',
      successBody2:
        'Talebin yetkililere bildirim ile iletildi. Birkaç dakika içinde Steam ' +
        'hesabına giriş önceliği eklenecektir.',
      successStep1Title: 'Discord rolün',
      successStep1Body: 'Destekçi rolü birkaç dakika içinde Discord hesabına tanımlanıyor; rozet, renk ve özel kanal onunla birlikte geliyor.',
      successStep2Title: 'Sunucu giriş önceliği',
      successStep2Body: 'Giriş önceliği birkaç dakika içinde yetkililer tarafından Steam hesabına eklenecektir.',
      successStep3Title: 'Üyeliğin',
      successStep3Body: 'Yenileme tarihini ve iptal düğmesini profilinde bulabilirsin.',
      successNote: "Rol veya giriş önceliğin birkaç dakika içinde gelmediyse lütfen Discord'da destek talebi açınız.",
      goProfile: 'Profiline git',

      pendingTitle: 'Ödemeni henüz göremedik',
      pendingBody:
        'Ödeme alındıysa üyelik genellikle birkaç dakika içinde görünür. Kaybolan ' +
        'bir şey yok, birazdan tekrar kontrol et.',
      pendingNote: "Birkaç dakika sonra hâlâ görünmüyorsa Discord'da destek talebi aç, elle tanımlarız.",
      recheck: 'Tekrar kontrol et',

      failedTitle: 'Ödeme tamamlanmadı',
      failedBody:
        'Ödeme sayfası kapatıldı ya da işlem tamamlanamadı. Hesabından herhangi bir ' +
        'tahsilat yapılmadı.',
      failedNote: "Kartından çekim olduğu halde bu sayfayı görüyorsan Discord'da destek talebi aç.",
      retry: 'Tekrar dene',

      signedOutTitle: 'Üyeliğini görmek için giriş yap',
      signedOutBody: 'Bir üyeliği onu satın alan Discord hesabından tanıyoruz, o yüzden girişli olman gerekiyor.',
    },

    // Girişli destekçi akışı (profil sayfasının kendisi için T.profile)
    ctaSignIn: 'Discord ile giriş yap',
    ctaLinkSteam: 'Steam hesabını bağla',
    ctaSignInNote: 'Önce giriş yap. Ayrıcalıklar Discord hesabına tanımlanıyor.',
    ctaLinkSteamNote: "Önce Steam'i bağla: sunucu slotu SteamID64'e tanımlanıyor.",
    ctaAlreadySupporter: 'Zaten destekçisin',
    ctaAlreadyNote: 'Üyeliğini profilinden yönetebilirsin.',
    ctaError: 'Ödeme sayfası açılamadı. Birazdan tekrar dene.',
  },

  // ── turksletloose.com/profile ────────────────────────────────────────────────
  profile: {
    pageTitle: 'Profil',
    navLabel: 'Profil',
    title: 'Profilin',
    lead: 'Discord hesabın, Steam bağlantın ve destekçi üyeliğin.',
    signIn: 'Discord ile giriş yap',
    // Çubuk için kısa etiket: Discord işareti zaten nasıl olduğunu söylüyor.
    navSignIn: 'Giriş Yap',
    signOut: 'Çıkış Yap',
    signedOutTitle: 'Profilini görmek için giriş yap',
    signedOutBody: 'Discord ile giriş yaptığında Steam bağlantın ve üyeliğin burada görünür.',
    loading: 'Yükleniyor…',

    discordTitle: 'Discord hesabı',
    discordNote: 'Ayrıcalıklar bu hesaba tanımlanır.',

    steamTitle: 'Steam hesabı',
    steamNone: 'Henüz bağlı bir Steam hesabı yok.',
    steamWhy: "Sunucu öncelikli girişi SteamID64'e tanımlıyor, bu yüzden doğrulanmış bir hesap gerekiyor.",
    steamLink: 'Steam hesabını bağla',
    steamRelink: 'Başka bir hesap bağla',
    steamUnlink: 'Bağlantıyı kaldır',
    steamVerified: 'Steam üzerinden doğrulandı',
    steamUnverified: 'Yönetim tarafından girilmiş. Doğrulamak için sen bağla.',
    steamNoName: 'Ad alınamadı',
    steamFailed: 'Steam bu girişi doğrulamadı. Lütfen tekrar dene.',
    steamTaken: 'Bu Steam hesabı başka bir Discord hesabına bağlı.',

    supporterTitle: 'Destekçi üyeliği',
    supporterNone: 'Henüz destekçi değilsin.',
    supporterActive: 'Aktif',
    supporterInactive: 'Pasif',
    supporterRenews: '{date} tarihinde yenilenir',
    supporterEnds: 'İptal edildi. Ayrıcalıkların {date} tarihine kadar sürer',
    supporterCancel: 'Üyeliği iptal et',
    supporterCancelTitle: 'Destekçi üyeliğin iptal edilsin mi?',
    supporterCancelBody: 'Ayrıcalıkların {date} tarihine kadar sürer. Sonrasında üyelik biter ve bir daha ücret alınmaz.',
    supporterCancelBodyNoDate: 'Ayrıcalıkların ödemesini yaptığın dönemin sonuna kadar sürer. Sonrasında üyelik biter ve bir daha ücret alınmaz.',
    supporterCancelConfirm: 'Evet, iptal et',
    supporterCancelKeep: 'Vazgeç',
    supporterCancelError: "Whop'a ulaşılamadı. Hiçbir şey iptal edilmedi, tekrar dener misin?",
    supporterCancelBlocked: "İptal şu an alınamıyor. Discord'dan yaz, biz hallederiz.",
    supporterResume: 'Üyeliği devam ettir',
    supporterResumeNote: '{date} tarihine kadar bu kararından dönebilirsin.',
    supporterResumeError: "Whop'a ulaşılamadı. İptal hâlâ geçerli, tekrar dener misin?",
    supporterResumeBlocked: "Devam ettirme şu an alınamıyor. Discord'dan yaz, biz hallederiz.",
    supporterBilling: 'Makbuzlar ve ödeme yöntemi',
    supporterCta: 'Destekçi Ol',
    supporterUnavailable: 'Üyelik durumu şu an okunamadı.',
  },

  join: {
    brand: 'Turks Let Loose',
    tagline: 'Wardogs · Rekabetçi Klan',
    homeLink: 'Ana sayfa',
    pageTitle: 'Bize Katıl',
    heroKicker: 'BAŞVURULAR AÇIK',
    heroTitle: 'Bize katıl.',
    heroLead:
      "Wardogs'un önde gelen rekabetçi takımlarından birine dahil ol. " +
      "Eğitimlere katıl, Avrupa'da maçlara çık.",
    applyCta: 'Discord ile Başvur',
    discordCta: 'Discord',
    continueCta: 'Başvurunu görüntüle',
    scrollHint: 'Nasıl işliyor?',

    pillars: {
      title: 'Seni ne bekliyor',
      communityTitle: 'Samimi ortam',
      communityBody: 'Tanıdığın insanlarla oynarsın. Discord maç geceleri dışında da hareketlidir.',
      matchesTitle: 'Rekabetçi maçlar',
      matchesBody: 'Organize Avrupa klanlarına karşı scrim ve turnuvalar.',
      drillsTitle: 'Düzenli eğitimler',
      drillsBody: 'Takvime bağlı eğitim geceleri. Yeni taktikler, pozisyon çalışması ve tekrar.',
      academyTitle: 'Akademi yolu',
      academyBody: 'Yeni gelenler akademide başlar, hazır olduklarında ana kadroya yükseltilir.',
    },

    requirements: {
      title: 'Senden beklentimiz',
      age: '18 yaş ve üzeri.',
      mic: 'Çalışan bir mikrofon ve onu etkili kullanma isteği.',
      experience: 'Rolünü bilecek kadar Wardogs deneyimi.',
      attendance: 'Maçlara ve eğitimlere aktif katılım.',
      steam: "Giriş yapabildiğin bir Steam hesabı. SteamID64'ün Steam üzerinden doğrulanır.",
    },

    steps: {
      title: 'Nasıl işliyor?',
      one: 'Discord ile giriş yap',
      oneBody: 'Sadece kullanıcı adını ve avatarını okuyoruz, başka hiçbir şeyi değil.',
      two: 'Steam hesabını bağla',
      twoBody: "Steam üzerinden tek bir giriş. SteamID64'ün yazılmış değil, doğrulanmış olarak kaydedilir.",
      three: 'Formu doldur',
      threeBody: 'Birkaç dakika sürer. Oyun içi isim, yaş ve oyun saatin.',
      four: 'Kanalın açılır',
      fourBody: "Discord'umuzda sana özel bir #başvuru kanalı oluşturulur.",
      five: 'Sana dönüş yaparız',
      fiveBody: 'Yönetim başvurunu değerlendirir, sonucu DM ile ve kanalından öğrenirsin.',
    },

    faq: {
      title: 'Başvurmadan önce',
      q1: "Discord'unuzda olmam gerekiyor mu?",
      a1: 'Evet. Önce sunucuya katılman gerekiyor, çünkü başvuru kanalın orada açılıyor.',
      q2: 'Maçlara katılım zorunlu mu?',
      a2: 'Takımımızda hiçbir konuda zorunluluk yoktur fakat takım oyuncularının ayda en az bir maça katılarak aktiflik göstermeleri beklenmektedir.',
      q3: 'Reddedilirsem ne olur?',
      a3: 'Gerekçesini öğrenirsin ve 30 gün sonra tekrar başvurabilirsin.',
      q4: 'Steam hesabımı neden istiyorsunuz?',
      a4:
        "Kadro, oyun sunucusu ve maç listelerimiz SteamID64 üzerinden çalışıyor. " +
        "Steam ile giriş yapmak ID'nin sana ait olduğunu kanıtlar. Şifreni görmüyoruz, " +
        'o ID dışında hiçbir şey okumuyoruz.',
    },

    footerNote: 'Bir topluluk klanıdır. Oyun veya yapımcısı ile bağlantılı değildir.',
    copyright: '© {year} Turks Let Loose',

    errors: {
      token_failed: "Discord'a bağlanılamadı. Lütfen tekrar deneyin.",
      no_token: 'Discord bir oturum döndürmedi. Lütfen tekrar deneyin.',
      user_fetch_failed: 'Discord profilin okunamadı.',
      generic: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },

    // ── /apply ─────────────────────────────────────────────────────────────
    apply: {
      title: 'Başvuru',
      loading: 'Yükleniyor…',
      signedInAs: 'Giriş yapan',
      signOut: 'Çıkış yap',
      loadError: 'Oturumun yüklenemedi. Tekrar giriş yapmayı dene.',
      signIn: 'Discord ile giriş yap',
      signInBody: 'Başlamak için Discord ile giriş yap. Sadece kullanıcı adını ve avatarını okuyoruz.',

      // Eligibility gates
      notInGuildTitle: "Önce Discord'umuza katıl",
      notInGuildBody:
        'Başvuru kanalın Discord sunucumuzun içinde açılıyor, bu yüzden başvurmadan ' +
        'önce sunucuya üye olman gerekiyor.',
      openDiscord: 'Discord davetini aç',
      noInvite: 'Bir üyeden davet bağlantısı iste, sonra bu sayfaya geri dön.',
      recheck: 'Katıldım, tekrar kontrol et',

      alreadyMemberTitle: 'Zaten bizdensin',
      alreadyMemberBody: 'Discord hesabında zaten üye rolü var, başvurmana gerek yok.',
      alreadyAcademyTitle: 'Zaten akademidesin',
      alreadyAcademyBody: 'Discord hesabında zaten akademi rolü var, yeni bir başvuruya gerek yok.',

      pendingTitle: 'Başvurun inceleniyor',
      pendingBody: 'Yönetimimiz başvuruna bakıyor. Sonucu DM ile ve başvuru kanalından öğreneceksin.',
      approvedTitle: 'Başvurun onaylandı',
      approvedBody: 'Aramıza hoş geldin. Geri kalan her şey başvuru kanalında ilerliyor.',
      cooldownTitle: 'Yakın zamanda başvurdun',
      cooldownBody: 'Son başvurun olumlu sonuçlanmadı. {date} tarihinden itibaren tekrar başvurabilirsin.',
      openChannel: 'Başvuru kanalıma git',

      // Steam gate — kimlik Steam üzerinden kanıtlanır, forma yazılmaz
      steamGateTitle: 'Steam hesabını bağla',
      steamGateBody:
        'Formdan önce, kimsenin doğrulayamayacağı bir ID yazmanı istemek yerine kim ' +
        "olduğunu Steam'e soruyoruz. Tek bir giriş yeterli; sonrasında kadromuzda " +
        'gerçekten sahibi olduğun hesap yazar.',
      steamConnect: 'Steam ile giriş yap',
      steamFailed: 'Steam bu girişi doğrulamadı. Lütfen tekrar dene.',
      steamTaken: 'Bu Steam hesabı başka bir Discord hesabına bağlı.',
      steamVerified: 'Steam üzerinden doğrulandı',
      steamNoName: 'Ad alınamadı',
      steamRelink: 'Başka bir hesap bağla',

      // Form
      formTitle: 'Bize kendinden bahset',
      formLead: 'Dört alan zorunlu. Geri kalanı seni doğru kadroya yerleştirmemize yardım ediyor.',
      required: 'zorunlu',
      optional: 'isteğe bağlı',
      ingameName: 'Oyun içi isim',
      ingameNameHint: 'Wardogs içinde göründüğü şekliyle.',
      steamAccount: 'Steam hesabı',
      age: 'Yaş',
      hours: 'Wardogs saati',
      roles: 'Oynadığın roller',
      rolesHint: 'Rahat oynadığın bütün rolleri seç.',
      playstyle: 'Oyun tarzın',
      playstyleHint: 'Seçtiğin rolde detay vermen kadro yerleşiminde işimizi kolaylaştırır. Hotzone kovalamak mı, FOB kurmak mı? Medic mi Anti-Tank mı?',
      previousClans: 'Önceki klanların',
      previousClansHint: 'Daha önce nerede oynadın, neden ayrıldın?',
      referral: 'Bizi nereden duydun?',
      about: 'Eklemek istediklerin',
      aboutHint: 'Neden Turks Let Loose? Yönetimin bilmesini istediğin her şey.',
      submit: 'Başvuruyu gönder',
      submitting: 'Gönderiliyor…',
      validationError: 'Lütfen zorunlu alanların hepsini doldur.',
      submitError: 'Başvurun gönderilemedi. Lütfen tekrar dene.',

      // Success
      successTitle: 'Başvurun gönderildi',
      successBody:
        "Discord'umuzda sana özel bir kanal açtık. Yönetimimiz seninle oradan yazışacak, " +
        'sen de merak ettiklerini aynı yerden sorabilirsin.',
      successDm: 'Bağlantıyı ayrıca DM ile de gönderdik.',
      successNoChannel:
        'Kanalını otomatik açamadık. Başvurun kaydedildi, yönetimimiz Discord üzerinden ' +
        'seninle iletişime geçecek.',
      backHome: 'Ana sayfaya dön',
    },
  },

  // ── Dashboard → Yönetim → Destekçiler ────────────────────────────────────
  briefing: {
    title: 'Briefing',
    lead:
      'Bir maç seç, yayınlanan kadrodaki oyuncular ve yedekler Briefing ses odasında mı gör. ' +
      'Birkaç saniyede bir tazelenir.',
    channelStatus: 'Kanal durumu',
    refreshStatus: 'Durumu güncelle',
    inChannelNow: 'Odada {n} kişi',
    match: 'Maç',
    upcoming: 'Yaklaşan',
    past: 'Geçmiş',
    noMatches: 'Son iki haftada ya da ileride maç yok.',
    loadError: 'Briefing verisi yüklenemedi.',
    statusError: 'Kanal durumu yazılamadı.',
    notSynced: 'Discord bağlantısı henüz senkronlanıyor, kimin sesli odada olduğu bilinmiyor.',
    rosterNotPosted:
      "Bu maçın kadrosu henüz yayınlanmadı. Kadro Discord'a gönderildikten sonra " +
      'yoklama açılır. Yalnızca kadrodakiler ve yedekler kontrol edilir.',
    noRosterTag: 'kadro yok',
    bench: 'Yedek',
    presentCount: 'Odada {here} / {total}',
    emptyRoster: 'Yayınlanan kadroda kimse yok.',
    here: 'Odada',
    elsewhere: '{channel} odasında',
    elsewhereUnknown: 'Başka bir odada',
    absent: 'Seste değil',
    missing: 'Eksik',
    extras: 'Odada ama kadroda değil',
    filterAll: 'Hepsi',
    filterMissing: 'Yalnızca eksikler',
    briefingAt: 'Briefing {time}',
    matchAt: 'Maç {time}',
  },
  supporters: {
    title: 'Destekçiler',
    lead:
      "Whop üzerinden alınan bütün destekçi üyelikleri, birkaç dakikada bir " +
      'buraya yansıtılır. Salt okunur: aboneliği Whop, rolü de Whop\'un Discord ' +
      'uygulaması yönetir. Burası liste, kontrol paneli değil.',
    loading: 'Yükleniyor…',
    loadError: 'Destekçiler yüklenemedi.',
    syncError: "Whop'a ulaşılamadı. Liste değişmedi.",
    empty: 'Burada üyelik yok.',
    refresh: "Whop'tan güncelle",
    syncing: 'Güncelleniyor…',
    searchPlaceholder: 'Discord, Steam, e-posta, ID…',
    notConfigured:
      'Whop API anahtarı tanımlı değil, bu yüzden hiçbir şey okunamıyor. ' +
      'WHOP_API_KEY girilene kadar liste boş kalır.',

    filters: { active: 'Aktif', inactive: 'Sona ermiş', all: 'Tümü' },
    active: 'Aktif',
    inactive: 'Pasif',
    cancelling: 'İptal edildi',
    unknownBuyer: 'Bilinmeyen alıcı',
    verified: 'doğrulanmış',
    unverified: 'doğrulanmamış',
    noSteamName: 'Ad alınamadı',
    notNotified: 'Henüz gönderilmedi',
    startedOn: '{date} tarihinde başladı',
    renewsOn: '{date} tarihinde yenilenir',
    openWhop: "Whop'ta aç",
    rawToggle: 'Ham Whop verisi',
    footnote: 'İptal edilen üyelikler listede kalır. Burası bugün ödeyenler değil, tüm geçmiştir.',

    fields: {
      steamName: 'Steam hesabı',
      steamId: 'SteamID64',
      product: 'Ürün',
      price: 'Tutar',
      email: 'E-posta',
      membershipId: 'Üyelik ID',
      planId: 'Plan ID',
      notified: 'Yönetime bildirildi',
    },
  },

  // ── Dashboard → Yönetim → Başvurular ─────────────────────────────────────
  applications: {
    title: 'Başvurular',
    loading: 'Yükleniyor…',
    loadError: 'Başvurular yüklenemedi.',
    refresh: 'Yenile',
    searchPlaceholder: 'Başvuran ara…',
    empty: 'Burada henüz başvuru yok.',
    count: '{n} başvuru',

    filters: {
      pending: 'Bekleyen',
      approved: 'Onaylanan',
      rejected: 'Reddedilen',
      all: 'Tümü',
    },

    status: {
      pending: 'Bekliyor',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
    },

    appliedOn: '{date} tarihinde başvurdu',
    reviewedBy: '{name} değerlendirdi',
    openChannel: 'Discord kanalı',
    noChannel: 'Kanal yok',
    createChannel: 'Kanal oluştur',
    channelClosed: 'Kanal kapatıldı',
    creatingChannel: 'Oluşturuluyor…',
    channelError: 'Kanal oluşturulamadı.',

    steamProfile: 'Steam',
    noSteam: 'Steam bağlı değil',
    details: 'Detaylar',
    hideDetails: 'Detayları gizle',

    fields: {
      ingameName: 'Oyun içi isim',
      applied: 'Başvuru',
      age: 'Yaş',
      hours: 'Wardogs saati',
      playstyle: 'Oyun tarzı',
      previousClans: 'Önceki klanları',
      referral: 'Bizi nereden duydu',
      about: 'Notu',
      discord: 'Discord',
    },

    approve: 'Onayla',
    reject: 'Reddet',
    approveTitle: 'Başvuruyu onayla',
    rejectTitle: 'Başvuruyu reddet',
    approveBody: 'Başvuran DM ile ve başvuru kanalından bilgilendirilir.',
    rejectBody: 'Başvuran DM ile ve başvuru kanalından bilgilendirilir.',
    grantAcademyRole: "Discord'da Akademi rolünü ver",
    noteLabel: 'Başvurana not',
    notePlaceholder: "İsteğe bağlı. DM'e eklenir.",
    rejectNotePlaceholder: "İsteğe bağlı. Gerekçe DM'e eklenir.",
    cancel: 'Vazgeç',
    confirmApprove: 'Onayla',
    confirmReject: 'Reddet',
    working: 'İşleniyor…',
    actionError: 'İşlem başarısız oldu. Lütfen tekrar deneyin.',
    reviewNote: 'Değerlendirme notu',

    delete: 'Sil',
    deleteTitle: 'Başvuruyu sil',
    deleteBody: 'Başvuru kaydı silinir. Bu işlem geri alınamaz.',
    deleteChannelToo: 'Discord kanalını da sil',
    confirmDelete: 'Sil',
  },
}

export const translations = { en, tr }
export type Translations = typeof en
